// This file is auto-generated by @hey-api/openapi-ts

import { type HttpRequest, httpResource } from '@angular/common/http';

import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { ActivitiesCreateData, ActivitiesCreateResponse, ActivitiesListData, ActivitiesListResponse, ActivityFavoritesRemoveFavoriteData, ActivityFavoritesRemoveFavoriteResponse, ActivityFavoritesSetFavoriteData, ActivityFavoritesSetFavoriteResponse, ActivityInstancesConfirmStickerUploadData, ActivityInstancesConfirmStickerUploadResponse, ActivityInstancesCopyData, ActivityInstancesCopyResponse, ActivityInstancesCreateActivityPedagogicalCustomFieldData, ActivityInstancesCreateActivityPedagogicalCustomFieldResponse, ActivityInstancesCreateEmptyData, ActivityInstancesCreateEmptyResponse, ActivityInstancesDeleteActivityPedagogicalCustomFieldData, ActivityInstancesDeleteActivityPedagogicalCustomFieldResponse, ActivityInstancesDeleteData, ActivityInstancesDeleteResponse, ActivityInstancesDetailData, ActivityInstancesDetailResponse, ActivityInstancesGenerateCoverData, ActivityInstancesGenerateCoverResponse, ActivityInstancesGenerateStickerData, ActivityInstancesGenerateStickerResponse, ActivityInstancesGetActivityPedagogicalCustomFieldsData, ActivityInstancesGetActivityPedagogicalCustomFieldsResponse, ActivityInstancesGetActivityPedagogicalFieldsData, ActivityInstancesGetActivityPedagogicalFieldsResponse, ActivityInstancesLinkContextDocumentsData, ActivityInstancesLinkContextDocumentsResponse, ActivityInstancesListData, ActivityInstancesListResponse, ActivityInstancesPrepareStickerUploadData, ActivityInstancesPrepareStickerUploadResponse, ActivityInstancesReorderActivityPedagogicalCustomFieldsData, ActivityInstancesReorderActivityPedagogicalCustomFieldsResponse, ActivityInstancesReorderActivityPedagogicalFieldsData, ActivityInstancesReorderActivityPedagogicalFieldsResponse, ActivityInstancesUnlinkContextDocumentData, ActivityInstancesUnlinkContextDocumentResponse, ActivityInstancesUpdateActivityPedagogicalCustomFieldData, ActivityInstancesUpdateActivityPedagogicalCustomFieldResponse, ActivityInstancesUpdateActivityPedagogicalCustomFieldValueData, ActivityInstancesUpdateActivityPedagogicalCustomFieldValueResponse, ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityData, ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityResponse, ActivityInstancesUpdateActivityPedagogicalFieldValueData, ActivityInstancesUpdateActivityPedagogicalFieldValueResponse, ActivityInstancesUpdateActivityPedagogicalFieldVisibilityData, ActivityInstancesUpdateActivityPedagogicalFieldVisibilityResponse, ActivityInstancesUpdateCoverFramingData, ActivityInstancesUpdateCoverFramingResponse, ActivityInstancesUpdateDescriptionData, ActivityInstancesUpdateDescriptionResponse, ActivityInstancesUpdateDurationData, ActivityInstancesUpdateDurationResponse, ActivityInstancesUpdateFieldLayoutData, ActivityInstancesUpdateFieldLayoutResponse, ActivityInstancesUpdateInstructionsData, ActivityInstancesUpdateInstructionsResponse, ActivityInstancesUpdateNameData, ActivityInstancesUpdateNameResponse, ActivityInstancesUpdateSectionsData, ActivityInstancesUpdateSectionsResponse, ActivityInstancesUpdateSubTopicData, ActivityInstancesUpdateSubTopicResponse, ActivityInstancesUpdateTagsData, ActivityInstancesUpdateTagsResponse, ActivityInstancesUpdateVisibilityData, ActivityInstancesUpdateVisibilityResponse, ActivityIntentsInterpretData, ActivityIntentsInterpretResponse, ActivitySuggestionAdaptationAdaptData, ActivitySuggestionAdaptationAdaptResponse, ActivitySuggestionsGenerateData, ActivitySuggestionsGenerateResponse, ActivityTemplatesCopyData, ActivityTemplatesCopyResponse, ActivityTemplatesDetailData, ActivityTemplatesDetailResponse, ActivityTemplatesListData, ActivityTemplatesListResponse, ActivityTypeRecommendationsRecommendData, ActivityTypeRecommendationsRecommendResponse, AttachmentsAttachmentContentData, CalendarEventByIdDeleteData, CalendarEventByIdDeleteResponse, CalendarEventByIdDetailData, CalendarEventByIdDetailResponse, CalendarEventByIdUpdateData, CalendarEventByIdUpdateResponse, CalendarEventByIdUpdateVisibilityData, CalendarEventByIdUpdateVisibilityResponse, CalendarEventsListData, CalendarEventsListResponse, CalendarEventsScheduleData, CalendarEventsScheduleResponse, DocumentByIdDeleteData, DocumentByIdDeleteResponse, DocumentByIdDownloadData, DocumentByIdGetActivityUsageData, DocumentByIdGetActivityUsageResponse, DocumentByIdGetData, DocumentByIdGetResponse, DocumentByIdUpdateVisibilityData, DocumentByIdUpdateVisibilityResponse, DocumentsConfirmData, DocumentsConfirmResponse, DocumentsListData, DocumentsListResponse, DocumentsOpenData, DocumentsOpenResponse, ImagesConfirmData, ImagesConfirmResponse, ImagesOpenData, ImagesOpenResponse, InstitutionGetData, InstitutionGetResponse, ITagPathFilterGrouperGroupData, ITagPathFilterGrouperGroupResponse, MembersCreateData, MembersCreateResponse, MembersDeactivateData, MembersDeactivateResponse, MembersListData, MembersListResponse, MembersResendInviteData, MembersResendInviteResponse, ProjectActivitiesAddData, ProjectActivitiesAddResponse, ProjectActivitiesCopyData, ProjectActivitiesCopyResponse, ProjectActivitiesRemoveData, ProjectActivitiesRemoveResponse, ProjectActivitiesReorderData, ProjectActivitiesReorderResponse, ProjectByIdDeleteData, ProjectByIdDeleteResponse, ProjectByIdDetailData, ProjectByIdDetailResponse, ProjectByIdUpdateDescriptionData, ProjectByIdUpdateDescriptionResponse, ProjectByIdUpdateNameData, ProjectByIdUpdateNameResponse, ProjectsCreateData, ProjectsCreateResponse, ProjectsListData, ProjectsListResponse, TagsListData, TagsListResponse, TeachersCreateProfileData, TeachersCreateProfileResponse, TeachersGetProfileData, TeachersGetProfileResponse, TeachersMeData, TeachersMeResponse, TeachersUpdateProfileData, TeachersUpdateProfileResponse, TopicsListData, TopicsListResponse, TopicTagsListData, TopicTagsListResponse } from '../types.gen';

export const iTagPathFilterGrouperGroupRequest = <ThrowOnError extends boolean = false>(options: Options<ITagPathFilterGrouperGroupData, ThrowOnError>): HttpRequest<ITagPathFilterGrouperGroupResponse> => (options?.client ?? client).requestOptions<ITagPathFilterGrouperGroupResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/',
    ...options
});

/**
 * Unified activity list: the templates of the caller's tenant, the signed-in teacher's own
 * instances, and colleagues' `Tenant`-visibility instances in the caller's tenant (isOwner false).
 * Nothing of another tenant is ever listed. Cursor pagination; limit default 20, range 1-100.
 * Optional `tagPath` (ltree, repeated query param), `searchTerm` (accent- and case-insensitive
 * substring), `activityType` (`Template` | `Instance`), `createdByMe`, `favoritesOnly`,
 * `durationValue` + `durationUnit` (maximum duration, normalized to minutes; ≤),
 * `createdFrom` / `createdTo` (ISO 8601, `createdAt` range).
 * Sorting: `favoritesFirst` boost, then `sortBy` (`createdAt` | `name`) + `sortDir`
 * (`asc` | `desc`, default `desc`).
 *
 * `totalCount`: total activities matching the current filters (SQL `COUNT(*)`, without cursor or
 * `limit`). Returned on every response, including when paginating.
 */
export const activitiesListRequest = <ThrowOnError extends boolean = false>(options?: Options<ActivitiesListData, ThrowOnError>): HttpRequest<ActivitiesListResponse> => (options?.client ?? client).requestOptions<ActivitiesListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activities',
    ...options
});

export const activitiesCreateRequest = <ThrowOnError extends boolean = false>(options: Options<ActivitiesCreateData, ThrowOnError>): HttpRequest<ActivitiesCreateResponse> => (options?.client ?? client).requestOptions<ActivitiesCreateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activities',
    ...options
});

/**
 * Idempotens kedvenc eltávolítás. Ismeretlen `activityId` → 404.
 * Hitelesítetlen hívó → 401. Siker → 204.
 */
export const activityFavoritesRemoveFavoriteRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityFavoritesRemoveFavoriteData, ThrowOnError>): HttpRequest<ActivityFavoritesRemoveFavoriteResponse> => (options?.client ?? client).requestOptions<ActivityFavoritesRemoveFavoriteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/activities/{activityId}/favorite',
    ...options
});

/**
 * Idempotens kedvenc hozzáadás. Ismeretlen vagy a hívó elől rejtett `activityId` → 404.
 * Hitelesítetlen hívó → 401. Siker → 204.
 */
export const activityFavoritesSetFavoriteRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityFavoritesSetFavoriteData, ThrowOnError>): HttpRequest<ActivityFavoritesSetFavoriteResponse> => (options?.client ?? client).requestOptions<ActivityFavoritesSetFavoriteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activities/{activityId}/favorite',
    ...options
});

/**
 * A bejelentkezett pedagógus saját tevékenységei (`owner_id` alapján, `IUserContext`-ből).
 * Opcionális `tagPath` (ltree, ismételt paraméter, dimenzióba csoportosítva — root, a `tevekenyseg`
 * root alatt az első két szegmens: azonos dimenzión belül OR + ancestor-egyezés, dimenziók között
 * AND) és `searchTerm` (ékezet-/kis-nagybetű-
 * érzéketlen összefüggő részszó a `name`, `topicName`, `subTopicName`, `tags.label` mezőkre) szűrők,
 * a tulajdonos-szűrővel AND-ben. Érvénytelen `tagPath`/`limit`/túl hosszú `searchTerm` → 400.
 * `limit` alapértelmezés: 20, tartomány: 1–1000. Cursor pagination.
 */
export const activityInstancesListRequest = <ThrowOnError extends boolean = false>(options?: Options<ActivityInstancesListData, ThrowOnError>): HttpRequest<ActivityInstancesListResponse> => (options?.client ?? client).requestOptions<ActivityInstancesListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-instances',
    ...options
});

/**
 * Létrehoz és perzisztál egy tartalmilag üres, de a domain-invariánsoknak megfelelő
 * `ActivityInstance`-t a bejelentkezett pedagógus tulajdonában, projekt-hozzárendelés nélkül.
 *
 * Nincs kérés-törzs: a tulajdonos az `IUserContext`-ből jön; a placeholder Név/Leírás/első Lépés
 * a create-empty handler konstansai (K1 C2). A meglévő AI-köteges `POST /v1/activities` végpont
 * érintetlen marad.
 */
export const activityInstancesCreateEmptyRequest = <ThrowOnError extends boolean = false>(options?: Options<ActivityInstancesCreateEmptyData, ThrowOnError>): HttpRequest<ActivityInstancesCreateEmptyResponse> => (options?.client ?? client).requestOptions<ActivityInstancesCreateEmptyResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances',
    ...options
});

/**
 * A bejelentkezett pedagógus törli a saját tevékenységét (`ActivityInstance`). A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance törölhető:
 * idegen tulajdonú, nem létező vagy Template-típusú sor → 404. A kapcsolt `activity_tags` sorok az
 * ON DELETE CASCADE FK révén törlődnek. Sikeres törlés → 204 (üres törzs). A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}`.
 */
export const activityInstancesDeleteRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesDeleteData, ThrowOnError>): HttpRequest<ActivityInstancesDeleteResponse> => (options?.client ?? client).requestOptions<ActivityInstancesDeleteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/activity-instances/{id}',
    ...options
});

/**
 * Egy tevékenység-példány (`ActivityInstance`) részletei, amelyet a bejelentkezett pedagógus láthat:
 * a saját instance-a, vagy egy kolléga a hívó intézményével megosztott (`Tenant` láthatóságú)
 * instance-a, ez utóbbi csak olvasásra (`isOwner` false). Minden más sor → 404: egy kolléga privát
 * instance-a, egy másik intézmény bármely sora, nem létező vagy Template-típusú sor. A `detail`
 * a lista mezőin túl az `instructions` (óra menete) és `attachments` (a címkéken keresztül elért,
 * deduplikált mellékletek) mezőket is tartalmazza. A futásidejű `/api` prefixet a `Program.cs`
 * adja → valós URL `/api/v1/activity-instances/{id}`.
 */
export const activityInstancesDetailRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesDetailData, ThrowOnError>): HttpRequest<ActivityInstancesDetailResponse> => (options?.client ?? client).requestOptions<ActivityInstancesDetailResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-instances/{id}',
    ...options
});

/**
 * A bejelentkezett pedagógus Kontextus-dokumentumokat csatol a saját tevékenységéhez
 * (`ActivityInstance`) — köteg: egy hívás, több dokumentum. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance-hoz
 * csatolható: idegen tulajdonú, nem létező vagy Template-típusú sor → 404. A csatolás idempotens
 * (a már csatolt id-t kihagyja), és a Kontextus a katalógus `attachments`-től KÜLÖN fogalom. A
 * köteg atomi: bármely ismeretlen / nem saját / nem `Indexed` id → 400 (a köteg egyben elutasítva),
 * a max. 20-as korlát túllépése szintén → 400 (a sor nem módosul). Konkurens duplikátum-csatolási
 * versenyhelyzet, amit a handler korlátozott újrapróbálkozása nem tudott feloldani → 409
 * (a kérés egyszerűen újraküldhető). Siker → 200 + a frissített `detail` válasz. A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/context-documents`.
 */
export const activityInstancesLinkContextDocumentsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesLinkContextDocumentsData, ThrowOnError>): HttpRequest<ActivityInstancesLinkContextDocumentsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesLinkContextDocumentsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/context-documents',
    ...options
});

/**
 * A bejelentkezett pedagógus levesz egy Kontextus-dokumentumot a saját tevékenységéről
 * (`ActivityInstance`). Ez NEM a Dokumentumtár-törlés: csak a tevékenység↔dokumentum kapcsolatot
 * bontja, a fájl a `documents` táblában (és a tárolóban) megmarad. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része: idegen tulajdonú, nem létező vagy
 * Template-típusú sor → 404. `linkType: other` → 200 + a frissített `detail` (idempotens: a már
 * leválasztott kapcsolat is 200). `linkType: context` → **409**, a sor megmarad. A futásidejű
 * `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/context-documents/{documentId}`.
 */
export const activityInstancesUnlinkContextDocumentRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUnlinkContextDocumentData, ThrowOnError>): HttpRequest<ActivityInstancesUnlinkContextDocumentResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUnlinkContextDocumentResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/activity-instances/{id}/context-documents/{documentId}',
    ...options
});

/**
 * The signed-in teacher saves the framing of the current cover of an own activity instance (KT-270).
 * Not found, a colleague's or another tenant's instance, a template, or an activity without a current
 * cover → 404.
 * A missing, malformed or out-of-range property, or a missing or malformed body → 400; nothing changes.
 * A non-JSON `Content-Type` → 415 with no body; nothing changes.
 * `coverId` not the current cover → 409 `ActivityCover.CoverChanged`; nothing changes.
 * The stored framing is tied to `coverId`, so regenerating resets it to the defaults without a
 * write; this route never changes the image.
 * Success → 200 with the saved cover.
 * Runtime prefix `/api` from `Program.cs` → real URL `/api/v1/activity-instances/{id}/cover/framing`.
 */
export const activityInstancesUpdateCoverFramingRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateCoverFramingData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateCoverFramingResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateCoverFramingResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/cover/framing',
    ...options
});

/**
 * The signed-in teacher generates a new cover for an own activity instance (KT-270), manually or
 * through the client's automatic triggers — one generic route, no caller flag.
 * Resource-oriented sub-collection Create, not an ADR 10 custom method (the KT-648 precedent).
 * No request body. Synchronous: the response arrives after Vellum uploaded the image and Kt.Api
 * published and attached it.
 * Order: owner check (404) → image pipeline enabled (400 `ImageUpload.Disabled`) → placeholder rule
 * (400 `ActivityCover.PlaceholderContent`) → key mint (500 `ImageStorageKey.InvalidTenantSegment`) →
 * activity content load → claim under the activity row lock: the activity's generation record becomes
 * `Requested` unless a fresh `Requested` record exists (409 `ActivityCover.GenerationInProgress`; a stale
 * one is overwritten; an activity deleted meanwhile → 404) → Vellum → publish → commit (one transaction:
 * lock the activity row, insert the media row, make it the current cover with default framing, mark
 * this attempt's record `Succeeded`) → 201.
 * Nothing before the claim writes anything or calls Vellum.
 * Any failure after the claim, an open circuit breaker included, marks the record `Failed` with its
 * `CoverGenerationFailure`; a client abort after the claim and before the commit marks it `Failed` with
 * `Aborted`; the previous cover stays current either way.
 * A client abort does not cancel a commit that has started; a commit that fails rolls back whole (the
 * previous cover stays current), marks the record `Failed` with `Unexpected` and answers 500.
 * If a later attempt took over this run's stale claim, this run's record updates are ignored (the
 * record stays as that attempt left it), yet its commit still makes its cover current; of the two
 * commits the later one wins.
 * Not found, a colleague's or another tenant's instance, or a template → 404, nothing written; also an
 * activity deleted before the claim, or found deleted at the commit (its record goes with it).
 * 502 codes: `CoverGeneration.Unavailable`, `CoverGeneration.Rejected`, `CoverGeneration.ImageRejected`.
 * 504 code: `CoverGeneration.Timeout` (the cover Vellum timeout or the publish budget elapsed; one
 * attempt, no retry).
 * Only a 502 or 504 carrying one of these codes in a ProblemDetails body comes from Kt.Api; a 502 or
 * 504 from the load balancer has no such body.
 * 500 codes: `ImageStorageKey.InvalidTenantSegment` (before the claim; nothing written) or
 * `Server failure`.
 * Runtime prefix `/api` from `Program.cs` → real URL `/api/v1/activity-instances/{id}/cover/generations`.
 */
export const activityInstancesGenerateCoverRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesGenerateCoverData, ThrowOnError>): HttpRequest<ActivityInstancesGenerateCoverResponse> => (options?.client ?? client).requestOptions<ActivityInstancesGenerateCoverResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/cover/generations',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének leírását. Mezőnkénti (field-scoped)
 * `PUT` a `description` alerőforráson, az `updateName`-mel megegyező szemantikával. Idegen
 * tulajdonú, nem létező vagy Template-típusú sor → 404; üres vagy 1000 karakternél hosszabb leírás
 * → 400 (a sor nem módosul). Siker → 200 + a frissített `detail` válasz. A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/description`.
 */
export const activityInstancesUpdateDescriptionRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateDescriptionData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateDescriptionResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateDescriptionResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/description',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének időtartamát. Mezőnkénti
 * (field-scoped) `PUT` a `duration` alerőforráson. Az időtartam a domainben OPCIONÁLIS, ezért
 * `value: null` + `unit: null` törli (a válaszban a `duration` nem jelenik meg). Idegen tulajdonú,
 * nem létező vagy Template-típusú sor → 404; nem pozitív `value`, ismeretlen `unit` vagy félig
 * kitöltött (csak `value` VAGY csak `unit`) pár → 400 (a sor nem módosul). Siker → 200 + a frissített
 * `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/duration`.
 */
export const activityInstancesUpdateDurationRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateDurationData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateDurationResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateDurationResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/duration',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének szerkesztőoldali mező-elrendezését
 * (KT-903). Mezőnkénti (field-scoped) `PUT` a `field-layout` alerőforráson: a kapott lista a TELJES
 * elrendezést lecseréli (`fieldKey`, `sortOrder`, `visible`). A `name` mező mindig látható; ismeretlen
 * kulcs, duplikált kulcs vagy nem kompakt `sortOrder` → 400. Idegen tulajdonú vagy nem létező sor → 404.
 * Siker → 200 + a frissített `detail` válasz. Valós URL `/api/v1/activity-instances/{id}/field-layout`.
 */
export const activityInstancesUpdateFieldLayoutRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateFieldLayoutData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateFieldLayoutResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateFieldLayoutResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/field-layout',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének óra menetét. Mezőnkénti
 * (field-scoped) `PUT` az `instructions` alerőforráson: a kapott lista a TELJES lépéssorozatot
 * lecseréli (nincs részleges lépés-patch). Idegen tulajdonú, nem létező vagy Template-típusú sor →
 * 404; csak whitespace-t tartalmazó lépés vagy 5000 karakternél hosszabb lépés → 400 (a sor nem
 * módosul). Üres lista érvényes (az óramenet törölhető). Siker → 200 + a frissített `detail`
 * válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/instructions`.
 */
export const activityInstancesUpdateInstructionsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateInstructionsData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateInstructionsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateInstructionsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/instructions',
    ...options
});

/**
 * A bejelentkezett pedagógus átnevezi a saját tevékenységét (`ActivityInstance`). Mezőnkénti
 * (field-scoped) `PUT` a `name` alerőforráson: a törzs csak az új értéket (`value`) hordozza, így
 * az inline szerkesztés autosave-e nem küldi vissza a teljes erőforrást. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance nevezhető át:
 * idegen tulajdonú, nem létező vagy Template-típusú sor → 404. Üres vagy 255 karakternél hosszabb
 * név → 400 (ilyenkor a sor nem módosul). Siker → 200 + a frissített `detail` válasz. A futásidejű
 * `/api` prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/name`.
 */
export const activityInstancesUpdateNameRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateNameData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateNameResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateNameResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/name',
    ...options
});

/**
 * Activity-owned custom pedagogical fields (KT-1081). Owner only; non-owner / wrong tenant → 404.
 * Errors use RFC 7807 `title` codes such as `CustomPedagogicalField.NotFound`, `TooLong`, `InvalidOption`,
 * `OptionsTooFew`, `ImageSourceNotAllowed`. Reorder conflicts → 409 `CustomPedagogicalField.ReorderStale`.
 */
export const activityInstancesGetActivityPedagogicalCustomFieldsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesGetActivityPedagogicalCustomFieldsData, ThrowOnError>): HttpRequest<ActivityInstancesGetActivityPedagogicalCustomFieldsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesGetActivityPedagogicalCustomFieldsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields',
    ...options
});

export const activityInstancesCreateActivityPedagogicalCustomFieldRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesCreateActivityPedagogicalCustomFieldData, ThrowOnError>): HttpRequest<ActivityInstancesCreateActivityPedagogicalCustomFieldResponse> => (options?.client ?? client).requestOptions<ActivityInstancesCreateActivityPedagogicalCustomFieldResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields',
    ...options
});

export const activityInstancesDeleteActivityPedagogicalCustomFieldRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesDeleteActivityPedagogicalCustomFieldData, ThrowOnError>): HttpRequest<ActivityInstancesDeleteActivityPedagogicalCustomFieldResponse> => (options?.client ?? client).requestOptions<ActivityInstancesDeleteActivityPedagogicalCustomFieldResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields/{fieldId}',
    ...options
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateActivityPedagogicalCustomFieldResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateActivityPedagogicalCustomFieldResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields/{fieldId}',
    ...options
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldValueRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldValueData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateActivityPedagogicalCustomFieldValueResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateActivityPedagogicalCustomFieldValueResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields/{fieldId}/value',
    ...options
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldVisibilityRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields/{fieldId}/visibility',
    ...options
});

export const activityInstancesReorderActivityPedagogicalCustomFieldsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesReorderActivityPedagogicalCustomFieldsData, ThrowOnError>): HttpRequest<ActivityInstancesReorderActivityPedagogicalCustomFieldsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesReorderActivityPedagogicalCustomFieldsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/pedagogical-custom-fields:reorder',
    ...options
});

/**
 * Pedagogical fields on the activity editor card (KT-660). Owner only; missing rows on GET are virtual until the
 * first write materializes them.
 *
 * Errors are RFC 7807 ProblemDetails; the stable code is in `title` (same pattern as other activity-instance
 * routes). 404: missing / not visible activity (as on `detail`), or `PedagogicalField.NotFound` for an unknown
 * `fieldName`. 400: `Validation failure` with `errors` (malformed `fieldName` or request shape), or
 * `PedagogicalField.TooLong`, `PedagogicalField.InvalidOption`, `PedagogicalField.ImageSourceNotAllowed`,
 * `PedagogicalField.ReorderSetMismatch`. 409 (`:reorder` only): `PedagogicalField.ReorderStale`.
 */
export const activityInstancesGetActivityPedagogicalFieldsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesGetActivityPedagogicalFieldsData, ThrowOnError>): HttpRequest<ActivityInstancesGetActivityPedagogicalFieldsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesGetActivityPedagogicalFieldsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-instances/{id}/pedagogical-fields',
    ...options
});

export const activityInstancesUpdateActivityPedagogicalFieldVisibilityRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateActivityPedagogicalFieldVisibilityData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateActivityPedagogicalFieldVisibilityResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateActivityPedagogicalFieldVisibilityResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/pedagogical-fields/visibility',
    ...options
});

export const activityInstancesUpdateActivityPedagogicalFieldValueRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateActivityPedagogicalFieldValueData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateActivityPedagogicalFieldValueResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateActivityPedagogicalFieldValueResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/pedagogical-fields/{fieldName}/value',
    ...options
});

export const activityInstancesReorderActivityPedagogicalFieldsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesReorderActivityPedagogicalFieldsData, ThrowOnError>): HttpRequest<ActivityInstancesReorderActivityPedagogicalFieldsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesReorderActivityPedagogicalFieldsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/pedagogical-fields:reorder',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének tartalmi szekcióit. Mezőnkénti
 * (field-scoped) `PUT` a `sections` alerőforráson: a kapott lista a TELJES szekció-halmazt
 * lecseréli (nincs részleges szekció-patch). Minden elem `{ title, contentHtml }`; a szerver minden
 * szekcióhoz `id`-t rendel és a detail válasz `{ id, title, contentHtml }` objektumokat ad vissza.
 * Idegen tulajdonú, nem létező vagy Template-típusú sor → 404; üres/whitespace `title` vagy 255
 * karakternél hosszabb `title` vagy 20000 karakternél hosszabb `contentHtml` → 400 (a sor nem
 * módosul). Az üres `contentHtml` érvényes (default címmel felvett, üres tartalmú szekció is menthető);
 * üres lista is érvényes (minden szekció törölhető). Egy új vagy módosított `contentHtml`-ben erőforrást
 * csak `img[src]` tölthet be, és csak teljes `/images/{tenant}/{owner}/{token}.{ext}` host-relatív
 * útvonalról; bármely más forrás vagy `template` elem → 400 `ActivityContentSection.ImageSourceNotAllowed`.
 * A példány valamelyik tárolt szekciójával szó szerint egyező `contentHtml` nem ellenőrződik.
 * Siker → 200 + a frissített `detail` válasz. A
 * futásidejű `/api` prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/sections`.
 */
export const activityInstancesUpdateSectionsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateSectionsData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateSectionsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateSectionsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/sections',
    ...options
});

/**
 * The logged-in teacher generates a new sticker for an own activity instance (KT-648).
 * Resource-oriented, not an ADR 10 custom method: a generation creates a stored record (a media
 * row), so it is a standard Create on a sub-collection.
 * Synchronous: the response arrives after Vellum uploaded the image and Kt.Api confirmed and
 * attached it.
 * Generation uses the activity as currently saved (the client flushes its pending autosave
 * first). On success one transaction locks the activity row, inserts the new media row and
 * attaches it as the activity's current sticker, replacing the previous one if any (that
 * transaction is the commit point; no database row is written before it). Concurrent
 * generations on one activity all succeed; the later commit is current ("later attach wins").
 * Not found, a colleague's instance or a template → 404 (owner-only write, nothing written).
 * Client disconnect before the commit → the server stops waiting and writes no database row
 * (a file it already published stays unreferenced in `images/ready/`); there is no response to
 * read. A disconnect after the commit leaves the new sticker current (accepted race).
 * 502 codes (in `title`):
 * `StickerGeneration.Unavailable` (Vellum unreachable, its circuit breaker open, a non-2xx
 * Vellum status, or a Vellum body that does not parse or is JSON `null`),
 * `StickerGeneration.Rejected` (the workflow ended in any state other than `FULFILLED`, including
 * a run that failed because S3 refused its upload, for example a `Content-Type` other than the
 * signed one), or
 * `StickerGeneration.ImageRejected` (the workflow reported success but the uploaded object is
 * missing, empty, too large, stored with a `Content-Type` other than the declared one, or its
 * bytes are not of the configured sticker format).
 * No media row is written; the current sticker (if any) is unchanged. Retrying is allowed and
 * is billed again.
 * 504 code (in `title`): `StickerGeneration.Timeout` — Vellum did not answer within the
 * server's generation budget (for the whole call, response body included; one attempt, no retry), or
 * a storage call timed out (a cancellation that was not the caller's own). No media row is
 * written; a late upload lands in `images/pending/`, is never published, and is removed by the
 * pending lifecycle rule. A timeout that fires after the publish copy finished on S3 (the server's
 * publish budget, or an S3 client timeout racing the copy) leaves the copied `images/ready/`
 * object unreferenced; nothing deletes it.
 * 500 codes (in `title`):
 * `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code falls outside the image-key
 * segment pattern; checked before Vellum, so nothing is billed or written; repeats for the same
 * activity), or
 * `Server failure` (an unexpected exception such as an S3 error other than not-found or an
 * undocumented store answer; worth retrying).
 * No media row is written; the current sticker (if any) is unchanged.
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/generations`.
 */
export const activityInstancesGenerateStickerRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesGenerateStickerData, ThrowOnError>): HttpRequest<ActivityInstancesGenerateStickerResponse> => (options?.client ?? client).requestOptions<ActivityInstancesGenerateStickerResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/sticker/generations',
    ...options
});

/**
 * Step 1 of a sticker upload (KT-1193) — prepare. The logged-in teacher gets a presigned POST
 * for one pending sticker key of an own activity instance, under the activity's tenant and the
 * caller's owner prefix. `fileName` supplies only the extension; `jpeg`, `jpe` and `jfif`
 * canonicalise to `jpg`. Creates no resource and writes nothing, so it answers 200 (the
 * `POST /v1/images` precedent). Not found, a colleague's instance or a template → 404
 * (`ActivityInstance.NotFound`, checked first). No 409 path: nothing is claimed or stored.
 * 500 codes (in `title`): `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code
 * falls outside the image-key segment pattern; repeats for the same activity), or
 * `Server failure` (an unexpected exception such as a presigning failure; worth retrying).
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/uploads`.
 */
export const activityInstancesPrepareStickerUploadRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesPrepareStickerUploadData, ThrowOnError>): HttpRequest<ActivityInstancesPrepareStickerUploadResponse> => (options?.client ?? client).requestOptions<ActivityInstancesPrepareStickerUploadResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}/sticker/uploads',
    ...options
});

/**
 * Step 2 of a sticker upload (KT-1193) — confirm. Rebuilds the sticker key from the activity's
 * tenant, the caller and `uploadId`; unless the image is already published, inspects the pending
 * object and publishes it (the `PATCH /v1/images/{id}` checks). Then one transaction locks the
 * activity row, adds the media row and makes it the current sticker. Idempotent: a repeated or
 * concurrent confirm of the same upload answers the same media row and adds none.
 * 500 codes (in `title`): `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code
 * falls outside the image-key segment pattern; repeats for the same activity), or
 * `Server failure` (an unexpected exception such as an S3 error; worth retrying with the same
 * `uploadId`).
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/uploads/{uploadId}`.
 */
export const activityInstancesConfirmStickerUploadRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesConfirmStickerUploadData, ThrowOnError>): HttpRequest<ActivityInstancesConfirmStickerUploadResponse> => (options?.client ?? client).requestOptions<ActivityInstancesConfirmStickerUploadResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/activity-instances/{id}/sticker/uploads/{uploadId}',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének altémáját. Mezőnkénti
 * (field-scoped) `PUT` a `sub-topic` alerőforráson, az `updateName`-mel megegyező szemantikával:
 * a törzs csak az új `value` (SubTopic-azonosító) mezőt hordozza. Az altéma létezését a szerver a
 * read-modellen (`SubTopics`) ellenőrzi; a `topicName` a válaszban az új altéma témájából
 * származik. Idegen tulajdonú, nem létező vagy Template-típusú sor → 404; ismeretlen
 * SubTopic-azonosító → 400 (a sor nem módosul). A tulajdonos-ellenőrzés MEGELŐZI az altéma
 * létezés-ellenőrzését, tehát nem látható sor + ismeretlen altéma → 404. Kivétel az üres
 * (`00000000-…`) azonosító: azt a kérés-validátor utasítja vissza a handler előtt → 400. Siker →
 * 200 + a frissített `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/sub-topic`.
 */
export const activityInstancesUpdateSubTopicRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateSubTopicData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateSubTopicResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateSubTopicResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/sub-topic',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének címkéit. Mezőnkénti (field-scoped)
 * `PUT` a `tags` alerőforráson: a kapott `value` a TELJES címkehalmazt lecseréli (az abból kimaradt
 * `activity_tags` sorok törlődnek, az újak létrejönnek, a megmaradók változatlanok) — nincs külön
 * add/remove művelet. Üres lista → minden címke törlődik. Idegen tulajdonú, nem létező vagy
 * Template-típusú sor → 404; ismeretlen vagy üres (`00000000-…`) tag-id → 400 (a sor nem módosul).
 * Siker → 200 + a frissített `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja →
 * valós URL `/api/v1/activity-instances/{id}/tags`.
 */
export const activityInstancesUpdateTagsRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateTagsData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateTagsResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateTagsResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/activity-instances/{id}/tags',
    ...options
});

/**
 * The signed-in teacher updates visibility (`Private` / `Tenant`) on their own activity. Owner filter
 * is part of the WHERE clause: foreign-owned, missing, or Template row → 404. Unknown value, or
 * `Tenant` from a caller without an institution → 400. Success → 200 + updated `detail`. URL
 * `/api/v1/activity-instances/{id}/visibility` (runtime `/api` prefix from `Program.cs`).
 */
export const activityInstancesUpdateVisibilityRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesUpdateVisibilityData, ThrowOnError>): HttpRequest<ActivityInstancesUpdateVisibilityResponse> => (options?.client ?? client).requestOptions<ActivityInstancesUpdateVisibilityResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/activity-instances/{id}/visibility',
    ...options
});

/**
 * A pedagógus önálló, szerkeszthető másolatot hoz létre egy megtekintett tevékenységből (saját
 * `ActivityInstance` forrásból; sablont és kolléga megosztott instance-át az
 * `activity-templates/{id}:copy` másol). Google AIP-136 „custom method":
 * a nem-CRUD `copy` igét a kettőspontos `:copy` szuffix jelöli a member-scoped `{id}` erőforráson
 * (ld. ADR 10). A `{id}` a FORRÁS azonosítója; a törzs ÜRES (a szerver a másolandó mezőket a
 * forrásból olvassa, nincs felülírandó mező). Az eredmény mindig a hívó tulajdonában lévő új
 * `ActivityInstance`, `(másolat)` utótagú névvel; az eredeti sosem módosul. A Kontextus-dokumentumok
 * közül a másolatba azok kerülnek át, amelyeket a hívó most lát. `201 Created` + id-only
 * törzs (`id`) + `Location` fejléc az instance-GET-re (`CreatedAtRoute` →
 * `GetActivityInstanceById`). Nem látható forrás (idegen `ActivityInstance` vagy nem létező sor) →
 * 404; a képzett név > 255 → 400; hitelesítetlen hívó → 401. A futásidejű `/api` prefixet a
 * `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}:copy`.
 */
export const activityInstancesCopyRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityInstancesCopyData, ThrowOnError>): HttpRequest<ActivityInstancesCopyResponse> => (options?.client ?? client).requestOptions<ActivityInstancesCopyResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-instances/{id}:copy',
    ...options
});

/**
 * A pedagógus kérését megértett intentre fordítja. Ismeretlen tag-id vagy
 * altémakör-id → 400 (a workflow meg sem hívódik). A workflow elérhetetlensége,
 * sikertelen lefutása, valamint az az eset, amikor sikeres lefutás után sem ad
 * használható választ → 502; időtúllépése → 504 (legfeljebb kb. 45 másodperc).
 * Nem hoz létre és nem módosít semmit.
 */
export const activityIntentsInterpretRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityIntentsInterpretData, ThrowOnError>): HttpRequest<ActivityIntentsInterpretResponse> => (options?.client ?? client).requestOptions<ActivityIntentsInterpretResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-intents:interpret',
    ...options
});

/**
 * Érvénytelen bemenet, ismeretlen `subTopicId` vagy méret-túllépés → 400; hiányzó auth → 401;
 * a pedagógus sora nem létezik → 404 (nincs forrás-tevékenység lookup — a forrás-azonosító
 * hiánya a tervezett viselkedés, ez strukturálisan elérhetetlenné teszi a "forrás nem
 * található" hibát); a Dify-hívás elérhetetlen, elutasított vagy deszerializálhatatlan
 * választ ad → 502; időtúllépés → 504.
 */
export const activitySuggestionAdaptationAdaptRequest = <ThrowOnError extends boolean = false>(options: Options<ActivitySuggestionAdaptationAdaptData, ThrowOnError>): HttpRequest<ActivitySuggestionAdaptationAdaptResponse> => (options?.client ?? client).requestOptions<ActivitySuggestionAdaptationAdaptResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-suggestions:adapt',
    ...options
});

/**
 * Szinkron módon generál egy fix darabszámú tevékenység-javaslatot a leírás és az opcionális
 * tag-azonosítók alapján; a valós Dify Activity Generator workflow-t hívja. A helyszín
 * (`location`) feloldásához a bejelentkezett pedagógust az `IUserContext` adja, amíg nincs
 * valós auth ez egy MVP-ben rögzített teacherId-ra mutat.
 * Érvénytelen bemenet → 400; generálási hiba → 502; időtúllépés → 504.
 * A válaszban a fix darabszámnál kevesebb elem → 502.
 */
export const activitySuggestionsGenerateRequest = <ThrowOnError extends boolean = false>(options: Options<ActivitySuggestionsGenerateData, ThrowOnError>): HttpRequest<ActivitySuggestionsGenerateResponse> => (options?.client ?? client).requestOptions<ActivitySuggestionsGenerateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-suggestions:generate',
    ...options
});

/**
 * Opcionális címke-path szűrők. Ismételt query paraméter: `?tagPath=a&tagPath=b`.
 * Path-ok dimenzióba csoportosítva: a dimenzió az első ltree szegmens (root), kivéve a
 * `tevekenyseg` root-ot, ahol az első két szegmens (`tevekenyseg.tipus`, `tevekenyseg.munkaforma`,
 * `tevekenyseg.eszkoz`):
 * - ugyanazon dimenzión belül OR + ancestor egyezés (`ltree <@`) a sablon bármely tagjére;
 * - különböző dimenziók között AND.
 * Hiányzó `tagPath` = nincs szűrés. Érvénytelen ltree path → 400.
 *
 * Opcionális `searchTerm` szabad szöveges keresés: ékezet- és kis-/nagybetű-érzéketlen
 * (`unaccent(...) ILIKE '%...%'`) összefüggő részszó-illesztés a `name`, `topicName`,
 * `subTopicName` és bármely `tags.label` mezőre (OR), a `tagPath` szűrővel AND-ben.
 * A LIKE-metakarakterek (`%`, `_`, `\`) literálként illeszkednek. Üres/whitespace
 * `searchTerm` = nincs keresési szűrés. Maximális hossz 100 karakter; túllépés → 400.
 *
 * `limit` alapértelmezés: 20, tartomány: 1–100.
 */
export const activityTemplatesListRequest = <ThrowOnError extends boolean = false>(options?: Options<ActivityTemplatesListData, ThrowOnError>): HttpRequest<ActivityTemplatesListResponse> => (options?.client ?? client).requestOptions<ActivityTemplatesListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-templates',
    ...options
});

/**
 * Details of an activity shared with the caller's tenant: a template of the caller's tenant, or a
 * `Tenant`-visibility instance in the caller's tenant — a colleague's or the caller's own — always
 * read-only (`isOwner` false). A `Private` instance, even the caller's own, → 404; its detail is
 * `GET /v1/activity-instances/{id}`. Every row of another tenant, and an unknown id → 404.
 */
export const activityTemplatesDetailRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityTemplatesDetailData, ThrowOnError>): HttpRequest<ActivityTemplatesDetailResponse> => (options?.client ?? client).requestOptions<ActivityTemplatesDetailResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/activity-templates/{id}',
    ...options
});

/**
 * A pedagógus önálló, szerkeszthető `ActivityInstance`-t hoz létre a saját intézményének egy
 * `ActivityTemplate`-jéből. Google AIP-136 „custom method": a nem-CRUD `copy` igét a kettőspontos
 * `:copy` szuffix jelöli a member-scoped `{id}` erőforráson (ld. ADR 10). A `{id}` a FORRÁS template
 * azonosítója; a törzs ÜRES (a szerver a másolandó mezőket a forrásból olvassa). Az eredmény mindig a
 * hívó tulajdonában lévő új `ActivityInstance`, `(másolat)` utótagú névvel; a forrás template sosem
 * módosul. `201 Created` + id-only törzs (`id`) + `Location` fejléc az instance-GET-re
 * (`CreatedAtRoute` → `GetActivityInstanceById`, tehát az új `ActivityInstance`-re, NEM a template-re).
 * The source may be any `Tenant`-visibility instance in the caller's tenant, a colleague's or the
 * caller's own — the same set `detail` opens; the copy is the caller's own `Private` instance. Of an
 * instance source's context documents, the copy carries only those the caller may see: their own and
 * the tenant-shared ones, never the colleague's private ones (KT-851 FR-6.3). A
 * `Private` instance, even the caller's own, a row of another tenant, or an unknown id → 404; derived
 * name > 255 → 400; unauthenticated caller → 401. A futásidejű `/api` prefixet a `Program.cs` adja →
 * valós URL `/api/v1/activity-templates/{id}:copy`.
 */
export const activityTemplatesCopyRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityTemplatesCopyData, ThrowOnError>): HttpRequest<ActivityTemplatesCopyResponse> => (options?.client ?? client).requestOptions<ActivityTemplatesCopyResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-templates/{id}:copy',
    ...options
});

/**
 * A strukturált teacher input (`description` + opcionális tagek / NAT / duration)
 * alapján ajánlott tevékenység-altípusokat ad vissza a `GetTagsItem` szerkezetében.
 * Ismeretlen tag-id vagy altémakör-id → kihagyás + warning log (a workflow a
 * feloldott mezőkkel továbbra is meghívódik). Ha egyetlen Label sem oldható fel,
 * vagy a workflow lefutott, de nem adott ajánlást, a válasz üres tömb (200); a workflow
 * sikertelen lefutása, elérhetetlensége vagy időtúllépése (legfeljebb kb. 45 másodperc) → 500.
 */
export const activityTypeRecommendationsRecommendRequest = <ThrowOnError extends boolean = false>(options: Options<ActivityTypeRecommendationsRecommendData, ThrowOnError>): HttpRequest<ActivityTypeRecommendationsRecommendResponse> => (options?.client ?? client).requestOptions<ActivityTypeRecommendationsRecommendResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/activity-types:recommend',
    ...options
});

/**
 * Egy melléklet tartalmának elérése rövid életű, aláírt (presigned) S3 URL-en át.
 * A válasz 302 átirányítás — a fájl bájtjai sosem mennek át a backenden.
 * A friss URL kérésenként keletkezik, így a detail panel nyitva tartása nem okoz lejárt linket.
 * A `mode` kötelező: `view` → inline megnyitás; `download` → letöltés (`Content-Disposition`).
 * Ismeretlen `attachmentId` → 404.
 */
export const attachmentsAttachmentContentRequest = <ThrowOnError extends boolean = false>(options: Options<AttachmentsAttachmentContentData, ThrowOnError>): HttpRequest<unknown> => (options?.client ?? client).requestOptions<unknown, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/attachments/{attachmentId}',
    ...options
});

/**
 * A hívó saját eseményei és a kollégák `Tenant` láthatóságú eseményei egy időablakra, keyset-lapozva.
 *
 * Időablak: `start`/`end` hiányában az aktuális ISO-hét (hétfő 00:00 UTC – következő hétfő
 * 00:00 UTC); ha csak az egyik érkezik, az ablak onnan (vagy odáig) 7 nap. `start >= end` → 400.
 * Az ablak UTC-alapú, nem a hívó helyi hete — a kliens explicit `start`/`end`-del határozza meg
 * a saját zónájának heti határait.
 *
 * Rendezés: `startsAt`, majd `id` (keyset). A `cursor` az előző lap `nextCursor`-a, opaque
 * string — a kliens ne értelmezze. `limit` alapértelmezés: 20, tartomány: 1–100.
 * `totalCount` ezen a végponton nincs kitöltve.
 *
 * A kukázott (soft delete) események is benne vannak a válaszban, `isDeleted: true`-val — a
 * naptár megjeleníti és onnan állítható vissza őket (PUT `deleted: false`). Kollégák `Tenant`
 * eseményei közül a kukázottak nem jelennek meg (`isDeleted` colleague branch).
 */
export const calendarEventsListRequest = <ThrowOnError extends boolean = false>(options?: Options<CalendarEventsListData, ThrowOnError>): HttpRequest<CalendarEventsListResponse> => (options?.client ?? client).requestOptions<CalendarEventsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/calendar-events',
    ...options
});

/**
 * `endsAt` hiányában az esemény hossza 45 perc (egy tanóra). `visibility: Tenant` tenant nélküli
 * hívótól → 400 (`ValidationProblemResponse`), ugyanúgy mint a visibility PATCH.
 */
export const calendarEventsScheduleRequest = <ThrowOnError extends boolean = false>(options: Options<CalendarEventsScheduleData, ThrowOnError>): HttpRequest<CalendarEventsScheduleResponse> => (options?.client ?? client).requestOptions<CalendarEventsScheduleResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/calendar-events',
    ...options
});

/**
 * Csak a tulajdonos törölhet; idegen vagy láthatatlan sor → 404.
 */
export const calendarEventByIdDeleteRequest = <ThrowOnError extends boolean = false>(options: Options<CalendarEventByIdDeleteData, ThrowOnError>): HttpRequest<CalendarEventByIdDeleteResponse> => (options?.client ?? client).requestOptions<CalendarEventByIdDeleteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/calendar-events/{eventId}',
    ...options
});

/**
 * Saját esemény (minden visibility) és kolléga `Tenant` esemény → 200, read-only ha `isOwner` false.
 * Idegen `Private` vagy láthatatlan sor → 404.
 */
export const calendarEventByIdDetailRequest = <ThrowOnError extends boolean = false>(options: Options<CalendarEventByIdDetailData, ThrowOnError>): HttpRequest<CalendarEventByIdDetailResponse> => (options?.client ?? client).requestOptions<CalendarEventByIdDetailResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/calendar-events/{eventId}',
    ...options
});

/**
 * Teljes-csere: minden mutable mező jelen. A `deleted` a soft-delete állapot (Google Drive
 * `trashed`-minta): `true` = kukába, `false` = visszaállítás. A `DELETE` ige ettől külön a végleges törlés.
 *
 * Konkurencia: a kérés nem hordoz verziót, a szemantika **last write wins** — két egyidejű
 * szerkesztés közül a később beérkező felülírja a korábbit, 409 nélkül. Nem tulajdonos (kolléga
 * `Tenant` esemény) → 404.
 */
export const calendarEventByIdUpdateRequest = <ThrowOnError extends boolean = false>(options: Options<CalendarEventByIdUpdateData, ThrowOnError>): HttpRequest<CalendarEventByIdUpdateResponse> => (options?.client ?? client).requestOptions<CalendarEventByIdUpdateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/calendar-events/{eventId}',
    ...options
});

/**
 * The signed-in teacher updates visibility (`Private` / `Tenant`) on their own calendar event. Foreign-owned,
 * missing, or invisible row → 404. Unknown value, or `Tenant` from a caller without an institution → 400.
 * Success → 200 + full `detail` body (mirror activity visibility PATCH).
 */
export const calendarEventByIdUpdateVisibilityRequest = <ThrowOnError extends boolean = false>(options: Options<CalendarEventByIdUpdateVisibilityData, ThrowOnError>): HttpRequest<CalendarEventByIdUpdateVisibilityResponse> => (options?.client ?? client).requestOptions<CalendarEventByIdUpdateVisibilityResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/calendar-events/{eventId}/visibility',
    ...options
});

/**
 * The documents the signed-in teacher may see inside their tenant: their own (`owner_id` ==
 * IUserContext.UserId), plus other teachers' documents whose visibility is `Tenant`. Another
 * teacher's `Private` document never appears. Each item's `isOwner` tells the caller's own apart.
 * Optional filters: `searchTerm` (fileName ILIKE), `fileType` (lowercased extension),
 * `status` (`DocumentStatus`; absent = every state), `visibility` (`DocumentVisibility`; absent = every value).
 * Paging: `page` (1-based), `pageSize` (1–100, default 10).
 * Sort: `sortBy` (`createdAt` | `fileName` | `fileType` | `fileSizeBytes` | `status` | `visibility` |
 * `ownerName`; default `createdAt`) + `sortDir` (`asc` | `desc`; default `desc`).
 */
export const documentsListRequest = <ThrowOnError extends boolean = false>(options?: Options<DocumentsListData, ThrowOnError>): HttpRequest<DocumentsListResponse> => (options?.client ?? client).requestOptions<DocumentsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/documents',
    ...options
});

/**
 * Step 2 — batch confirmation (the PATCH changes the state of the referenced documents).
 * The server HEADs each landed object, rejects and deletes anything over the 50 MB cap, and also
 * reads the first 16 KiB — a bounded, ranged read, never a full object transfer — to check the
 * detected content type against the type the declared extension promises, answering
 * `rejectedContentType` in the three cases listed on that enum member; the zero-byte case is
 * caught on the object's size, before any ranged read. Everything else moves to Uploaded, which
 * the poller then indexes. No document byte is transferred through the API on any path, and this
 * request makes no outbound call to Agno: submission stays with the poller.
 * Idempotent: a record already past `Pending` comes back as `uploaded`.
 * Unknown `state`, or a batch that is empty or larger than ten → 400; missing identity → 401.
 */
export const documentsConfirmRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentsConfirmData, ThrowOnError>): HttpRequest<DocumentsConfirmResponse> => (options?.client ?? client).requestOptions<DocumentsConfirmResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/documents',
    ...options
});

/**
 * Step 1 — batch open. Validation (1..10 files, allowed extension, declared size > 0), a per-user
 * slot check (max 20 non-`Indexed` records), then per file a Pending record with a
 * server-generated `storage_key` and a presigned PUT URL. The bytes never touch the API.
 * Errors → 400 ProblemDetails (empty or oversized batch, forbidden extension, slot limit);
 * missing identity → 401.
 */
export const documentsOpenRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentsOpenData, ThrowOnError>): HttpRequest<DocumentsOpenResponse> => (options?.client ?? client).requestOptions<DocumentsOpenResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/documents',
    ...options
});

/**
 * Hard delete of the caller's own document from the KT database. Ownership: `owner_id`.
 * The record and the cascading join rows commit first; only then does the best-effort Agno delete
 * run (`DELETE /documents/{knowledge_ref}/{document_id}`, knowledge_ref = the configured
 * KnowledgesId; an Agno failure does not undo the local delete that already happened, and an Agno
 * 404 counts as success), followed — if a `storage_key` exists — by the best-effort object-store
 * delete (S3 `DeleteObject`), which also removes the object from the bucket.
 * Foreign or missing record → 404; missing auth → 401. Success → 204.
 */
export const documentByIdDeleteRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentByIdDeleteData, ThrowOnError>): HttpRequest<DocumentByIdDeleteResponse> => (options?.client ?? client).requestOptions<DocumentByIdDeleteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/documents/{id}',
    ...options
});

/**
 * Metadata and status of the caller's own document (`owner_id` == IUserContext.UserId).
 * Poll this, not the first page of the list. Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdGetRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentByIdGetData, ThrowOnError>): HttpRequest<DocumentByIdGetResponse> => (options?.client ?? client).requestOptions<DocumentByIdGetResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/documents/{id}',
    ...options
});

/**
 * How many of the caller's own activities the document is attached to. A COUNT over the join table
 * with an owner filter. Not part of the list response.
 * Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdGetActivityUsageRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentByIdGetActivityUsageData, ThrowOnError>): HttpRequest<DocumentByIdGetActivityUsageResponse> => (options?.client ?? client).requestOptions<DocumentByIdGetActivityUsageResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/documents/{id}/activity-usage',
    ...options
});

/**
 * Sets who may see the document beyond the owner (`documents.visibility`). Only the owner
 * (`owner_id` == IUserContext.UserId) may change visibility. Writable values: `Private`, `Tenant`
 * (`Tenant` requires tenant context). Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdUpdateVisibilityRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentByIdUpdateVisibilityData, ThrowOnError>): HttpRequest<DocumentByIdUpdateVisibilityResponse> => (options?.client ?? client).requestOptions<DocumentByIdUpdateVisibilityResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/documents/{id}/visibility',
    ...options
});

/**
 * The signed-in teacher downloads an `Indexed` document they may see: their own (`owner_id` ==
 * IUserContext.UserId) or one a colleague shared with the tenant (`visibility` `Tenant`), such as a
 * context document of a colleague's shared activity (KT-851 FR-6.4). The response is a 302 redirect to
 * a short-lived presigned S3 GET URL (`Content-Disposition: attachment`); bytes never pass through
 * the API. A colleague's `Private` document, another tenant's document, or a missing record → 404;
 * visible but not `Indexed` → 400; missing auth → 401.
 * Not the catalog attachment download (`GET /v1/attachments/{attachmentId}`).
 */
export const documentByIdDownloadRequest = <ThrowOnError extends boolean = false>(options: Options<DocumentByIdDownloadData, ThrowOnError>): HttpRequest<unknown> => (options?.client ?? client).requestOptions<unknown, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/documents/{id}:download',
    ...options
});

/**
 * Step 1 — open. Mints the image's id and returns a presigned POST for its one key under the
 * caller's own tenant and owner prefix. Writes nothing.
 */
export const imagesOpenRequest = <ThrowOnError extends boolean = false>(options: Options<ImagesOpenData, ThrowOnError>): HttpRequest<ImagesOpenResponse> => (options?.client ?? client).requestOptions<ImagesOpenResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/images',
    ...options
});

/**
 * Step 2 — confirm. Rebuilds the key from the caller and the id; if the image is already
 * published, answers its path at once. Otherwise HEADs the current pending version, inspects
 * its first 16 KiB, and publishes exactly that version — a server-side copy to the location
 * the media host serves; publishing is what makes it served. A rejected version is never
 * copied and stays unserved. The `ready`/`rejected` status tag is best-effort bookkeeping: a
 * storage failure while tagging (reported or thrown by S3) is logged and never changes the
 * answer. Idempotent for a published image.
 */
export const imagesConfirmRequest = <ThrowOnError extends boolean = false>(options: Options<ImagesConfirmData, ThrowOnError>): HttpRequest<ImagesConfirmResponse> => (options?.client ?? client).requestOptions<ImagesConfirmResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/images/{id}',
    ...options
});

/**
 * A seedelt intézmény lekérdezése. Egyetlen intézmény feltételezés: az első
 * (és egyetlen) seedelt sort adja vissza. Seed hiányában `404`
 * (`Institution.NotFound`). Read-only, `AllowAnonymous`.
 */
export const institutionGetRequest = <ThrowOnError extends boolean = false>(options?: Options<InstitutionGetData, ThrowOnError>): HttpRequest<InstitutionGetResponse> => (options?.client ?? client).requestOptions<InstitutionGetResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/institution',
    ...options
});

/**
 * Lists members of the caller's MTP tenant (BFF over MTP `GET …/members`).
 * Returns every row MTP sends in one response (up to MTP's 5,000-member cap).
 * Requires `member.read` on the stored platform snapshot. Without it → `403`.
 * When MTP integration is not configured → `503`.
 * No teacher row for the caller → `404` (`Members.TeacherNotFound`).
 * MTP gateway failures → `502` / `504` (stable codes in ProblemDetails `title`, e.g.
 * `Mtp.Members.Unavailable`, `Mtp.Members.MalformedAnswer`, `Mtp.Members.Timeout`).
 */
export const membersListRequest = <ThrowOnError extends boolean = false>(options?: Options<MembersListData, ThrowOnError>): HttpRequest<MembersListResponse> => (options?.client ?? client).requestOptions<MembersListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/members',
    ...options
});

/**
 * Invites a new member for the caller's MTP tenant instance (BFF over MTP `POST …/members`).
 * Requires `member.invite` on the stored platform snapshot. Without it → `403`.
 * Duplicate e-mail in tenant → `409`. KT-local validation → `400`. MTP business-rule failures → `422`.
 */
export const membersCreateRequest = <ThrowOnError extends boolean = false>(options: Options<MembersCreateData, ThrowOnError>): HttpRequest<MembersCreateResponse> => (options?.client ?? client).requestOptions<MembersCreateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/members',
    ...options
});

/**
 * Deactivates a member (BFF over MTP `POST …/members/{userId}/deactivate`).
 * Requires `member.deactivate` on the snapshot. Success → `204`.
 */
export const membersDeactivateRequest = <ThrowOnError extends boolean = false>(options: Options<MembersDeactivateData, ThrowOnError>): HttpRequest<MembersDeactivateResponse> => (options?.client ?? client).requestOptions<MembersDeactivateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/members/{userId}:deactivate',
    ...options
});

/**
 * Resends the invitation for an inactive member (BFF over MTP `POST …/members/{userId}/resend-invite`).
 * Requires `member.invite` on the snapshot. Success → `204`.
 */
export const membersResendInviteRequest = <ThrowOnError extends boolean = false>(options: Options<MembersResendInviteData, ThrowOnError>): HttpRequest<MembersResendInviteResponse> => (options?.client ?? client).requestOptions<MembersResendInviteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/members/{userId}:resend-invite',
    ...options
});

/**
 * A bejelentkezett pedagógus SAJÁT projektjei (owner == IUserContext.UserId), TELJES listaként:
 * nincs lapozási és nincs keresési query paraméter (Q8, Q25). Sorrend: `createdAt` szerint
 * csökkenő, azonos időbélyegnél `id ASC` tie-break (Q29).
 * Üres projektek is szerepelnek. Más pedagógus projektjei nem.
 */
export const projectsListRequest = <ThrowOnError extends boolean = false>(options?: Options<ProjectsListData, ThrowOnError>): HttpRequest<ProjectsListResponse> => (options?.client ?? client).requestOptions<ProjectsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/projects',
    ...options
});

/**
 * Kézi projektlétrehozás a „Projektek" fejléc „+ Új projekt" gombjával. Üresen is
 * elmentődik — a mentés kötelező feltétele a nem üres (trim után) név; a leírás opcionális.
 * Siker: `201 Created` + `Location` fejléc (`GET /v1/projects/{projectId}`) + `ProjectDetail` törzs.
 * **404** = érvényes token, de nincs teacher rekord (konzisztens idegen erőforrással).
 * Új aggregátum jön létre, nincs mihez ütközni — ezért **nincs 409**.
 */
export const projectsCreateRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectsCreateData, ThrowOnError>): HttpRequest<ProjectsCreateResponse> => (options?.client ?? client).requestOptions<ProjectsCreateResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/projects',
    ...options
});

/**
 * Projekt törlése. CSAK a projektet és a tevékenység-előfordulásait törli — a tevékenységek
 * a könyvtárban maradnak. Idegen/hiányzó projekt → 404.
 *
 * Konkurencia: optimista. Ha a projekt időközben megváltozott vagy már törölték, a hívó kérése
 * („legyen törölve") teljesült — a válasz **404**, nem 409: nincs mit újrapróbálni.
 */
export const projectByIdDeleteRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectByIdDeleteData, ThrowOnError>): HttpRequest<ProjectByIdDeleteResponse> => (options?.client ?? client).requestOptions<ProjectByIdDeleteResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/projects/{projectId}',
    ...options
});

/**
 * Részletnézet: fejléc + sorrendezett tevékenységlista. Idegen/hiányzó projekt → 404.
 */
export const projectByIdDetailRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectByIdDetailData, ThrowOnError>): HttpRequest<ProjectByIdDetailResponse> => (options?.client ?? client).requestOptions<ProjectByIdDetailResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/projects/{projectId}',
    ...options
});

/**
 * Meglévő tevékenységek hozzáadása. A UI egykattintásos + gombbal egyelemű `activityIds` tömböt küld;
 * a batch atomi (`@minItems(1)` — üres tömb → 400). Ugyanaz a tevékenység többször is hozzáadható —
 * minden hívás új előfordulást hoz létre a lista végére, a batch elemeinek sorrendjében.
 *
 * Hozzáadható tevékenység = a hívó intézményének sablonja, a bejelentkezett pedagógus saját
 * instance-a, vagy egy kolléga intézménnyel megosztott (`Tenant` láthatóságú) instance-a — ugyanaz a
 * halmaz, amit a könyvtár mutat. **400** = üres batch (`@minItems(1)`), validáció. **404** = minden más
 * tevékenység (egy kolléga privát instance-a, egy másik intézmény bármely sora), nem létező id,
 * idegen/hiányzó projekt (nincs adatszivárgás). **409** = a projekt közben megváltozott.
 */
export const projectActivitiesAddRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectActivitiesAddData, ThrowOnError>): HttpRequest<ProjectActivitiesAddResponse> => (options?.client ?? client).requestOptions<ProjectActivitiesAddResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/projects/{projectId}/activities',
    ...options
});

/**
 * „Duplikálás" a projekt részletnézetének kártya-menüjéből (KT-338): egyetlen hívás létrehozza a
 * tevékenység másolatát a pedagógus könyvtárában, ÉS bemásolja azt ebbe a projektbe, a lista végére.
 * A másolat mindig saját `Instance`, akkor is, ha a forrás sablon vagy egy kolléga megosztott instance-a volt.
 *
 * A cél projekt a path-ból derül ki, ezért a másolat SOHA nem kerül be a forrás többi projektjébe —
 * a művelet a hívás helye szerinti egyetlen projektet érinti.
 *
 * Atomi: a másolat és az előfordulás egyetlen tranzakcióban jön létre, így nem marad árva másolat a
 * könyvtárban, ha a projekt írása meghiúsul.
 *
 * Másolható forrás = a hívó intézményének sablonja, a bejelentkezett pedagógus saját instance-a,
 * vagy egy kolléga intézménnyel megosztott instance-a — ugyanaz a szabály, mint az `add`-nál. A forrás
 * Kontextus-dokumentumai közül a másolatba csak azok kerülnek át, amelyeket a hívó lát: a sajátjai és a
 * tenanttal megosztottak (KT-851 FR-6.3).
 * **404** = minden más tevékenység, nem létező tevékenység, idegen/hiányzó projekt (adatszivárgás
 * nélkül). **409** = a projekt közben megváltozott.
 * AIP-136 custom method (`:copy`), a könyvtári `activity-instances/{id}:copy` mintájára.
 */
export const projectActivitiesCopyRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectActivitiesCopyData, ThrowOnError>): HttpRequest<ProjectActivitiesCopyResponse> => (options?.client ?? client).requestOptions<ProjectActivitiesCopyResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/projects/{projectId}/activities/{activityId}:copy',
    ...options
});

/**
 * „Kivétel a projektből" — CSAK a projektbeli előfordulást törli (`projectActivityId`), a tevékenység
 * (`activityId`) a könyvtárban marad. Siker: frissített `ProjectDetail` (mint `add`).
 * Hiányzó előfordulás, a `projectActivityId` másik projekthez tartozik, vagy az előfordulás a hívó
 * elől rejtett (a részletnézet sem mutatja) → 404 (adatszivárgás nélkül).
 * Ne keverjük a könyvtári tevékenységtörléssel (az `activityId`-t címzi, minden projektből kiveszi).
 * **409** = a projekt közben megváltozott.
 */
export const projectActivitiesRemoveRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectActivitiesRemoveData, ThrowOnError>): HttpRequest<ProjectActivitiesRemoveResponse> => (options?.client ?? client).requestOptions<ProjectActivitiesRemoveResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'DELETE',
    url: '/v1/projects/{projectId}/activities/{projectActivityId}',
    ...options
});

/**
 * Drag and drop utáni átrendezés (Q33): a body a projekt tevékenység-előfordulásainak **teljes**
 * listája a kívánt sorrendben. A művelet idempotens, és a projekt tárolt sorrendjét pontosan erre
 * a listára írja át — egy korábbi kivétel után maradt sorrend-hiány is megszűnik.
 *
 * **400** = üres vagy nem-UUID elemeket tartalmazó lista. **404** = idegen/hiányzó projekt.
 * **409** = a beküldött halmaz nem egyezik a projekt aktuális tevékenységeivel (hiányzó, többlet
 * vagy ismétlődő elem — elavult kliens-lista), vagy a projekt közben megváltozott.
 * A FE sorosítás csak UX — nem helyettesíti a szerveroldali konkurencia-ellenőrzést.
 * AIP-136 custom method (`:reorder`).
 */
export const projectActivitiesReorderRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectActivitiesReorderData, ThrowOnError>): HttpRequest<ProjectActivitiesReorderResponse> => (options?.client ?? client).requestOptions<ProjectActivitiesReorderResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/projects/{projectId}/activities:reorder',
    ...options
});

/**
 * A bejelentkezett pedagógus módosítja vagy üríti a saját projektjének leírását. Mezőnkénti
 * (field-scoped) `PUT` a `description` alerőforráson, az `updateName`-mel megegyező szemantikával.
 * Az ürítés a feature része, nem hiba: `null` és üres string egyaránt törli a leírást, és a
 * `ProjectDetail` válaszban a `description` ilyenkor hiányzik. Idegen vagy nem létező projekt →
 * 404; 2000 karakternél hosszabb leírás → 400 (a sor nem módosul). Siker → 200 + a teljes friss
 * `ProjectDetail`. Ha a projekt időközben megváltozott → 409.
 */
export const projectByIdUpdateDescriptionRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectByIdUpdateDescriptionData, ThrowOnError>): HttpRequest<ProjectByIdUpdateDescriptionResponse> => (options?.client ?? client).requestOptions<ProjectByIdUpdateDescriptionResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/projects/{projectId}/description',
    ...options
});

/**
 * A bejelentkezett pedagógus átnevezi a saját projektjét. Mezőnkénti (field-scoped) `PUT` a `name`
 * alerőforráson: a törzs csak az új értéket (`value`) hordozza, így a részletnézet inline
 * szerkesztésének autosave-e nem küldi vissza a teljes erőforrást. A tulajdonos-szűrő a WHERE
 * feltétel része, ezért idegen vagy nem létező projekt → 404, létezés-szivárgás nélkül. Üres,
 * csak whitespace vagy 255 karakternél hosszabb név → 400 (a sor nem módosul). Siker → 200 + a
 * teljes friss `ProjectDetail` (read-your-writes). Ha a projekt időközben megváltozott, az
 * aggregátum verzió-tokenje elutasítja az írást → 409.
 */
export const projectByIdUpdateNameRequest = <ThrowOnError extends boolean = false>(options: Options<ProjectByIdUpdateNameData, ThrowOnError>): HttpRequest<ProjectByIdUpdateNameResponse> => (options?.client ?? client).requestOptions<ProjectByIdUpdateNameResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PUT',
    url: '/v1/projects/{projectId}/name',
    ...options
});

/**
 * Opcionális `path` + `depth` szűrés: csak a megadott path alatt,
 * pontosan `depth` szinttel lejjebb lévő tagek (ltree exact-depth).
 * `depth` alapértelmezés: 1. Paraméterek nélkül a teljes flat lista.
 */
export const tagsListRequest = <ThrowOnError extends boolean = false>(options?: Options<TagsListData, ThrowOnError>): HttpRequest<TagsListResponse> => (options?.client ?? client).requestOptions<TagsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/tags',
    ...options
});

/**
 * A bejelentkezett pedagógus alapadatait és profilját (tag-ek id + path párként) adja vissza.
 * `hasProfile: false` esetén a kliens a profil-rögzítő képernyőre irányít.
 * `404` ha a Keycloak-identitáshoz nem tartozik teacher-rekord.
 */
export const teachersMeRequest = <ThrowOnError extends boolean = false>(options?: Options<TeachersMeData, ThrowOnError>): HttpRequest<TeachersMeResponse> => (options?.client ?? client).requestOptions<TeachersMeResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/teachers/me',
    ...options
});

/**
 * A bejelentkezett pedagógus tanítási profilját adja vissza.
 * `404` ha még nincs profil (a kliens ezt a kapu-döntésre is felhasználhatja).
 */
export const teachersGetProfileRequest = <ThrowOnError extends boolean = false>(options?: Options<TeachersGetProfileData, ThrowOnError>): HttpRequest<TeachersGetProfileResponse> => (options?.client ?? client).requestOptions<TeachersGetProfileResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/teachers/me/profile',
    ...options
});

/**
 * A bejelentkezett pedagógus tanítási profiljának szerkesztése: a megadott
 * egyedi tag-id halmaz a teljes tag-kollekciót lecseréli (dimenzió-agnosztikus).
 * Érvénytelen kérés (üres vagy nem-egyedi `tagIds`) → `400 Bad Request`.
 */
export const teachersUpdateProfileRequest = <ThrowOnError extends boolean = false>(options: Options<TeachersUpdateProfileData, ThrowOnError>): HttpRequest<TeachersUpdateProfileResponse> => (options?.client ?? client).requestOptions<TeachersUpdateProfileResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'PATCH',
    url: '/v1/teachers/me/profile',
    ...options
});

/**
 * Egyszeri tanítási profil rögzítése a bejelentkezett pedagógushoz.
 * Ha már van profil, `409 Conflict` választ ad.
 * Érvénytelen kérés (pl. hiányzó vagy üres `tagIds`) → `400 Bad Request`.
 * `201 Created` sikeres mentés esetén.
 */
export const teachersCreateProfileRequest = <ThrowOnError extends boolean = false>(options: Options<TeachersCreateProfileData, ThrowOnError>): HttpRequest<TeachersCreateProfileResponse> => (options?.client ?? client).requestOptions<TeachersCreateProfileResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'POST',
    url: '/v1/teachers/me/profile',
    ...options
});

/**
 * Tagek (path + depth szerint szűrve, mint a `GET /v1/tags`), és mindegyik alatt
 * a hozzá tartozó topicok a sub-topicjaikkal, egy válaszban.
 *
 * Csak az a tag jön vissza, amelyhez tartozik legalább egy topic, aminek van
 * legalább egy sub-topicja; a sub-topic nélküli topicok kimaradnak. Így a
 * `?path=tantargy&depth=1` a tantárgy-tageket adja (pl. `tantargy.angol`,
 * `tantargy.fizika`) a hozzájuk tartozó topic/sub-topic fával.
 *
 * `depth` alapértelmezés: 1, engedett tartomány 0–4. Paraméterek nélkül minden tag,
 * ugyanezzel a szűréssel.
 */
export const topicTagsListRequest = <ThrowOnError extends boolean = false>(options?: Options<TopicTagsListData, ThrowOnError>): HttpRequest<TopicTagsListResponse> => (options?.client ?? client).requestOptions<TopicTagsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/topic-tags',
    ...options
});

/**
 * Topics (each with its sub-topics joined), ordered by name. Plain list, no pagination.
 *
 * The optional `tagId` narrows the list to the topics tagged with one `tantargy.*`
 * subject tag id (obtained from `GET /v1/tags?path=tantargy&depth=1`), filtering via
 * the `topic_tags` join; an unknown or unlinked tag id returns 200 with an empty list.
 * Omitting `tagId` returns every topic, including those linked to no subject tag.
 */
export const topicsListRequest = <ThrowOnError extends boolean = false>(options?: Options<TopicsListData, ThrowOnError>): HttpRequest<TopicsListResponse> => (options?.client ?? client).requestOptions<TopicsListResponse, ThrowOnError>({
    responseStyle: 'data',
    method: 'GET',
    url: '/v1/topics',
    ...options
});

export const iTagPathFilterGrouperGroupResource = <ThrowOnError extends boolean = false>(options: () => Options<ITagPathFilterGrouperGroupData, ThrowOnError> | undefined) => httpResource<ITagPathFilterGrouperGroupResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? iTagPathFilterGrouperGroupRequest(opts) : undefined;
});

/**
 * Unified activity list: the templates of the caller's tenant, the signed-in teacher's own
 * instances, and colleagues' `Tenant`-visibility instances in the caller's tenant (isOwner false).
 * Nothing of another tenant is ever listed. Cursor pagination; limit default 20, range 1-100.
 * Optional `tagPath` (ltree, repeated query param), `searchTerm` (accent- and case-insensitive
 * substring), `activityType` (`Template` | `Instance`), `createdByMe`, `favoritesOnly`,
 * `durationValue` + `durationUnit` (maximum duration, normalized to minutes; ≤),
 * `createdFrom` / `createdTo` (ISO 8601, `createdAt` range).
 * Sorting: `favoritesFirst` boost, then `sortBy` (`createdAt` | `name`) + `sortDir`
 * (`asc` | `desc`, default `desc`).
 *
 * `totalCount`: total activities matching the current filters (SQL `COUNT(*)`, without cursor or
 * `limit`). Returned on every response, including when paginating.
 */
export const activitiesListResource = <ThrowOnError extends boolean = false>(options?: () => Options<ActivitiesListData, ThrowOnError> | undefined) => httpResource<ActivitiesListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activitiesListRequest(opts) : undefined;
});

export const activitiesCreateResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivitiesCreateData, ThrowOnError> | undefined) => httpResource<ActivitiesCreateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activitiesCreateRequest(opts) : undefined;
});

/**
 * Idempotens kedvenc eltávolítás. Ismeretlen `activityId` → 404.
 * Hitelesítetlen hívó → 401. Siker → 204.
 */
export const activityFavoritesRemoveFavoriteResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityFavoritesRemoveFavoriteData, ThrowOnError> | undefined) => httpResource<ActivityFavoritesRemoveFavoriteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityFavoritesRemoveFavoriteRequest(opts) : undefined;
});

/**
 * Idempotens kedvenc hozzáadás. Ismeretlen vagy a hívó elől rejtett `activityId` → 404.
 * Hitelesítetlen hívó → 401. Siker → 204.
 */
export const activityFavoritesSetFavoriteResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityFavoritesSetFavoriteData, ThrowOnError> | undefined) => httpResource<ActivityFavoritesSetFavoriteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityFavoritesSetFavoriteRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus saját tevékenységei (`owner_id` alapján, `IUserContext`-ből).
 * Opcionális `tagPath` (ltree, ismételt paraméter, dimenzióba csoportosítva — root, a `tevekenyseg`
 * root alatt az első két szegmens: azonos dimenzión belül OR + ancestor-egyezés, dimenziók között
 * AND) és `searchTerm` (ékezet-/kis-nagybetű-
 * érzéketlen összefüggő részszó a `name`, `topicName`, `subTopicName`, `tags.label` mezőkre) szűrők,
 * a tulajdonos-szűrővel AND-ben. Érvénytelen `tagPath`/`limit`/túl hosszú `searchTerm` → 400.
 * `limit` alapértelmezés: 20, tartomány: 1–1000. Cursor pagination.
 */
export const activityInstancesListResource = <ThrowOnError extends boolean = false>(options?: () => Options<ActivityInstancesListData, ThrowOnError> | undefined) => httpResource<ActivityInstancesListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesListRequest(opts) : undefined;
});

/**
 * Létrehoz és perzisztál egy tartalmilag üres, de a domain-invariánsoknak megfelelő
 * `ActivityInstance`-t a bejelentkezett pedagógus tulajdonában, projekt-hozzárendelés nélkül.
 *
 * Nincs kérés-törzs: a tulajdonos az `IUserContext`-ből jön; a placeholder Név/Leírás/első Lépés
 * a create-empty handler konstansai (K1 C2). A meglévő AI-köteges `POST /v1/activities` végpont
 * érintetlen marad.
 */
export const activityInstancesCreateEmptyResource = <ThrowOnError extends boolean = false>(options?: () => Options<ActivityInstancesCreateEmptyData, ThrowOnError> | undefined) => httpResource<ActivityInstancesCreateEmptyResponse>(() => {
    const opts = options ? options() : {};
    return activityInstancesCreateEmptyRequest(opts);
});

/**
 * A bejelentkezett pedagógus törli a saját tevékenységét (`ActivityInstance`). A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance törölhető:
 * idegen tulajdonú, nem létező vagy Template-típusú sor → 404. A kapcsolt `activity_tags` sorok az
 * ON DELETE CASCADE FK révén törlődnek. Sikeres törlés → 204 (üres törzs). A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}`.
 */
export const activityInstancesDeleteResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesDeleteData, ThrowOnError> | undefined) => httpResource<ActivityInstancesDeleteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesDeleteRequest(opts) : undefined;
});

/**
 * Egy tevékenység-példány (`ActivityInstance`) részletei, amelyet a bejelentkezett pedagógus láthat:
 * a saját instance-a, vagy egy kolléga a hívó intézményével megosztott (`Tenant` láthatóságú)
 * instance-a, ez utóbbi csak olvasásra (`isOwner` false). Minden más sor → 404: egy kolléga privát
 * instance-a, egy másik intézmény bármely sora, nem létező vagy Template-típusú sor. A `detail`
 * a lista mezőin túl az `instructions` (óra menete) és `attachments` (a címkéken keresztül elért,
 * deduplikált mellékletek) mezőket is tartalmazza. A futásidejű `/api` prefixet a `Program.cs`
 * adja → valós URL `/api/v1/activity-instances/{id}`.
 */
export const activityInstancesDetailResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesDetailData, ThrowOnError> | undefined) => httpResource<ActivityInstancesDetailResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesDetailRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus Kontextus-dokumentumokat csatol a saját tevékenységéhez
 * (`ActivityInstance`) — köteg: egy hívás, több dokumentum. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance-hoz
 * csatolható: idegen tulajdonú, nem létező vagy Template-típusú sor → 404. A csatolás idempotens
 * (a már csatolt id-t kihagyja), és a Kontextus a katalógus `attachments`-től KÜLÖN fogalom. A
 * köteg atomi: bármely ismeretlen / nem saját / nem `Indexed` id → 400 (a köteg egyben elutasítva),
 * a max. 20-as korlát túllépése szintén → 400 (a sor nem módosul). Konkurens duplikátum-csatolási
 * versenyhelyzet, amit a handler korlátozott újrapróbálkozása nem tudott feloldani → 409
 * (a kérés egyszerűen újraküldhető). Siker → 200 + a frissített `detail` válasz. A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/context-documents`.
 */
export const activityInstancesLinkContextDocumentsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesLinkContextDocumentsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesLinkContextDocumentsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesLinkContextDocumentsRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus levesz egy Kontextus-dokumentumot a saját tevékenységéről
 * (`ActivityInstance`). Ez NEM a Dokumentumtár-törlés: csak a tevékenység↔dokumentum kapcsolatot
 * bontja, a fájl a `documents` táblában (és a tárolóban) megmarad. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része: idegen tulajdonú, nem létező vagy
 * Template-típusú sor → 404. `linkType: other` → 200 + a frissített `detail` (idempotens: a már
 * leválasztott kapcsolat is 200). `linkType: context` → **409**, a sor megmarad. A futásidejű
 * `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/context-documents/{documentId}`.
 */
export const activityInstancesUnlinkContextDocumentResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUnlinkContextDocumentData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUnlinkContextDocumentResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUnlinkContextDocumentRequest(opts) : undefined;
});

/**
 * The signed-in teacher saves the framing of the current cover of an own activity instance (KT-270).
 * Not found, a colleague's or another tenant's instance, a template, or an activity without a current
 * cover → 404.
 * A missing, malformed or out-of-range property, or a missing or malformed body → 400; nothing changes.
 * A non-JSON `Content-Type` → 415 with no body; nothing changes.
 * `coverId` not the current cover → 409 `ActivityCover.CoverChanged`; nothing changes.
 * The stored framing is tied to `coverId`, so regenerating resets it to the defaults without a
 * write; this route never changes the image.
 * Success → 200 with the saved cover.
 * Runtime prefix `/api` from `Program.cs` → real URL `/api/v1/activity-instances/{id}/cover/framing`.
 */
export const activityInstancesUpdateCoverFramingResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateCoverFramingData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateCoverFramingResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateCoverFramingRequest(opts) : undefined;
});

/**
 * The signed-in teacher generates a new cover for an own activity instance (KT-270), manually or
 * through the client's automatic triggers — one generic route, no caller flag.
 * Resource-oriented sub-collection Create, not an ADR 10 custom method (the KT-648 precedent).
 * No request body. Synchronous: the response arrives after Vellum uploaded the image and Kt.Api
 * published and attached it.
 * Order: owner check (404) → image pipeline enabled (400 `ImageUpload.Disabled`) → placeholder rule
 * (400 `ActivityCover.PlaceholderContent`) → key mint (500 `ImageStorageKey.InvalidTenantSegment`) →
 * activity content load → claim under the activity row lock: the activity's generation record becomes
 * `Requested` unless a fresh `Requested` record exists (409 `ActivityCover.GenerationInProgress`; a stale
 * one is overwritten; an activity deleted meanwhile → 404) → Vellum → publish → commit (one transaction:
 * lock the activity row, insert the media row, make it the current cover with default framing, mark
 * this attempt's record `Succeeded`) → 201.
 * Nothing before the claim writes anything or calls Vellum.
 * Any failure after the claim, an open circuit breaker included, marks the record `Failed` with its
 * `CoverGenerationFailure`; a client abort after the claim and before the commit marks it `Failed` with
 * `Aborted`; the previous cover stays current either way.
 * A client abort does not cancel a commit that has started; a commit that fails rolls back whole (the
 * previous cover stays current), marks the record `Failed` with `Unexpected` and answers 500.
 * If a later attempt took over this run's stale claim, this run's record updates are ignored (the
 * record stays as that attempt left it), yet its commit still makes its cover current; of the two
 * commits the later one wins.
 * Not found, a colleague's or another tenant's instance, or a template → 404, nothing written; also an
 * activity deleted before the claim, or found deleted at the commit (its record goes with it).
 * 502 codes: `CoverGeneration.Unavailable`, `CoverGeneration.Rejected`, `CoverGeneration.ImageRejected`.
 * 504 code: `CoverGeneration.Timeout` (the cover Vellum timeout or the publish budget elapsed; one
 * attempt, no retry).
 * Only a 502 or 504 carrying one of these codes in a ProblemDetails body comes from Kt.Api; a 502 or
 * 504 from the load balancer has no such body.
 * 500 codes: `ImageStorageKey.InvalidTenantSegment` (before the claim; nothing written) or
 * `Server failure`.
 * Runtime prefix `/api` from `Program.cs` → real URL `/api/v1/activity-instances/{id}/cover/generations`.
 */
export const activityInstancesGenerateCoverResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesGenerateCoverData, ThrowOnError> | undefined) => httpResource<ActivityInstancesGenerateCoverResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesGenerateCoverRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének leírását. Mezőnkénti (field-scoped)
 * `PUT` a `description` alerőforráson, az `updateName`-mel megegyező szemantikával. Idegen
 * tulajdonú, nem létező vagy Template-típusú sor → 404; üres vagy 1000 karakternél hosszabb leírás
 * → 400 (a sor nem módosul). Siker → 200 + a frissített `detail` válasz. A futásidejű `/api`
 * prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/description`.
 */
export const activityInstancesUpdateDescriptionResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateDescriptionData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateDescriptionResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateDescriptionRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének időtartamát. Mezőnkénti
 * (field-scoped) `PUT` a `duration` alerőforráson. Az időtartam a domainben OPCIONÁLIS, ezért
 * `value: null` + `unit: null` törli (a válaszban a `duration` nem jelenik meg). Idegen tulajdonú,
 * nem létező vagy Template-típusú sor → 404; nem pozitív `value`, ismeretlen `unit` vagy félig
 * kitöltött (csak `value` VAGY csak `unit`) pár → 400 (a sor nem módosul). Siker → 200 + a frissített
 * `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/duration`.
 */
export const activityInstancesUpdateDurationResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateDurationData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateDurationResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateDurationRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének szerkesztőoldali mező-elrendezését
 * (KT-903). Mezőnkénti (field-scoped) `PUT` a `field-layout` alerőforráson: a kapott lista a TELJES
 * elrendezést lecseréli (`fieldKey`, `sortOrder`, `visible`). A `name` mező mindig látható; ismeretlen
 * kulcs, duplikált kulcs vagy nem kompakt `sortOrder` → 400. Idegen tulajdonú vagy nem létező sor → 404.
 * Siker → 200 + a frissített `detail` válasz. Valós URL `/api/v1/activity-instances/{id}/field-layout`.
 */
export const activityInstancesUpdateFieldLayoutResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateFieldLayoutData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateFieldLayoutResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateFieldLayoutRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének óra menetét. Mezőnkénti
 * (field-scoped) `PUT` az `instructions` alerőforráson: a kapott lista a TELJES lépéssorozatot
 * lecseréli (nincs részleges lépés-patch). Idegen tulajdonú, nem létező vagy Template-típusú sor →
 * 404; csak whitespace-t tartalmazó lépés vagy 5000 karakternél hosszabb lépés → 400 (a sor nem
 * módosul). Üres lista érvényes (az óramenet törölhető). Siker → 200 + a frissített `detail`
 * válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/instructions`.
 */
export const activityInstancesUpdateInstructionsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateInstructionsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateInstructionsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateInstructionsRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus átnevezi a saját tevékenységét (`ActivityInstance`). Mezőnkénti
 * (field-scoped) `PUT` a `name` alerőforráson: a törzs csak az új értéket (`value`) hordozza, így
 * az inline szerkesztés autosave-e nem küldi vissza a teljes erőforrást. A tulajdonos-szűrő
 * (`owner_id == IUserContext.UserId`) a WHERE feltétel része, így csak saját instance nevezhető át:
 * idegen tulajdonú, nem létező vagy Template-típusú sor → 404. Üres vagy 255 karakternél hosszabb
 * név → 400 (ilyenkor a sor nem módosul). Siker → 200 + a frissített `detail` válasz. A futásidejű
 * `/api` prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/name`.
 */
export const activityInstancesUpdateNameResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateNameData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateNameResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateNameRequest(opts) : undefined;
});

/**
 * Activity-owned custom pedagogical fields (KT-1081). Owner only; non-owner / wrong tenant → 404.
 * Errors use RFC 7807 `title` codes such as `CustomPedagogicalField.NotFound`, `TooLong`, `InvalidOption`,
 * `OptionsTooFew`, `ImageSourceNotAllowed`. Reorder conflicts → 409 `CustomPedagogicalField.ReorderStale`.
 */
export const activityInstancesGetActivityPedagogicalCustomFieldsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesGetActivityPedagogicalCustomFieldsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesGetActivityPedagogicalCustomFieldsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesGetActivityPedagogicalCustomFieldsRequest(opts) : undefined;
});

export const activityInstancesCreateActivityPedagogicalCustomFieldResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesCreateActivityPedagogicalCustomFieldData, ThrowOnError> | undefined) => httpResource<ActivityInstancesCreateActivityPedagogicalCustomFieldResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesCreateActivityPedagogicalCustomFieldRequest(opts) : undefined;
});

export const activityInstancesDeleteActivityPedagogicalCustomFieldResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesDeleteActivityPedagogicalCustomFieldData, ThrowOnError> | undefined) => httpResource<ActivityInstancesDeleteActivityPedagogicalCustomFieldResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesDeleteActivityPedagogicalCustomFieldRequest(opts) : undefined;
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateActivityPedagogicalCustomFieldResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateActivityPedagogicalCustomFieldRequest(opts) : undefined;
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldValueResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldValueData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateActivityPedagogicalCustomFieldValueResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateActivityPedagogicalCustomFieldValueRequest(opts) : undefined;
});

export const activityInstancesUpdateActivityPedagogicalCustomFieldVisibilityResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateActivityPedagogicalCustomFieldVisibilityResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateActivityPedagogicalCustomFieldVisibilityRequest(opts) : undefined;
});

export const activityInstancesReorderActivityPedagogicalCustomFieldsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesReorderActivityPedagogicalCustomFieldsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesReorderActivityPedagogicalCustomFieldsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesReorderActivityPedagogicalCustomFieldsRequest(opts) : undefined;
});

/**
 * Pedagogical fields on the activity editor card (KT-660). Owner only; missing rows on GET are virtual until the
 * first write materializes them.
 *
 * Errors are RFC 7807 ProblemDetails; the stable code is in `title` (same pattern as other activity-instance
 * routes). 404: missing / not visible activity (as on `detail`), or `PedagogicalField.NotFound` for an unknown
 * `fieldName`. 400: `Validation failure` with `errors` (malformed `fieldName` or request shape), or
 * `PedagogicalField.TooLong`, `PedagogicalField.InvalidOption`, `PedagogicalField.ImageSourceNotAllowed`,
 * `PedagogicalField.ReorderSetMismatch`. 409 (`:reorder` only): `PedagogicalField.ReorderStale`.
 */
export const activityInstancesGetActivityPedagogicalFieldsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesGetActivityPedagogicalFieldsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesGetActivityPedagogicalFieldsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesGetActivityPedagogicalFieldsRequest(opts) : undefined;
});

export const activityInstancesUpdateActivityPedagogicalFieldVisibilityResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateActivityPedagogicalFieldVisibilityData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateActivityPedagogicalFieldVisibilityResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateActivityPedagogicalFieldVisibilityRequest(opts) : undefined;
});

export const activityInstancesUpdateActivityPedagogicalFieldValueResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateActivityPedagogicalFieldValueData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateActivityPedagogicalFieldValueResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateActivityPedagogicalFieldValueRequest(opts) : undefined;
});

export const activityInstancesReorderActivityPedagogicalFieldsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesReorderActivityPedagogicalFieldsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesReorderActivityPedagogicalFieldsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesReorderActivityPedagogicalFieldsRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének tartalmi szekcióit. Mezőnkénti
 * (field-scoped) `PUT` a `sections` alerőforráson: a kapott lista a TELJES szekció-halmazt
 * lecseréli (nincs részleges szekció-patch). Minden elem `{ title, contentHtml }`; a szerver minden
 * szekcióhoz `id`-t rendel és a detail válasz `{ id, title, contentHtml }` objektumokat ad vissza.
 * Idegen tulajdonú, nem létező vagy Template-típusú sor → 404; üres/whitespace `title` vagy 255
 * karakternél hosszabb `title` vagy 20000 karakternél hosszabb `contentHtml` → 400 (a sor nem
 * módosul). Az üres `contentHtml` érvényes (default címmel felvett, üres tartalmú szekció is menthető);
 * üres lista is érvényes (minden szekció törölhető). Egy új vagy módosított `contentHtml`-ben erőforrást
 * csak `img[src]` tölthet be, és csak teljes `/images/{tenant}/{owner}/{token}.{ext}` host-relatív
 * útvonalról; bármely más forrás vagy `template` elem → 400 `ActivityContentSection.ImageSourceNotAllowed`.
 * A példány valamelyik tárolt szekciójával szó szerint egyező `contentHtml` nem ellenőrződik.
 * Siker → 200 + a frissített `detail` válasz. A
 * futásidejű `/api` prefixet a `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}/sections`.
 */
export const activityInstancesUpdateSectionsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateSectionsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateSectionsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateSectionsRequest(opts) : undefined;
});

/**
 * The logged-in teacher generates a new sticker for an own activity instance (KT-648).
 * Resource-oriented, not an ADR 10 custom method: a generation creates a stored record (a media
 * row), so it is a standard Create on a sub-collection.
 * Synchronous: the response arrives after Vellum uploaded the image and Kt.Api confirmed and
 * attached it.
 * Generation uses the activity as currently saved (the client flushes its pending autosave
 * first). On success one transaction locks the activity row, inserts the new media row and
 * attaches it as the activity's current sticker, replacing the previous one if any (that
 * transaction is the commit point; no database row is written before it). Concurrent
 * generations on one activity all succeed; the later commit is current ("later attach wins").
 * Not found, a colleague's instance or a template → 404 (owner-only write, nothing written).
 * Client disconnect before the commit → the server stops waiting and writes no database row
 * (a file it already published stays unreferenced in `images/ready/`); there is no response to
 * read. A disconnect after the commit leaves the new sticker current (accepted race).
 * 502 codes (in `title`):
 * `StickerGeneration.Unavailable` (Vellum unreachable, its circuit breaker open, a non-2xx
 * Vellum status, or a Vellum body that does not parse or is JSON `null`),
 * `StickerGeneration.Rejected` (the workflow ended in any state other than `FULFILLED`, including
 * a run that failed because S3 refused its upload, for example a `Content-Type` other than the
 * signed one), or
 * `StickerGeneration.ImageRejected` (the workflow reported success but the uploaded object is
 * missing, empty, too large, stored with a `Content-Type` other than the declared one, or its
 * bytes are not of the configured sticker format).
 * No media row is written; the current sticker (if any) is unchanged. Retrying is allowed and
 * is billed again.
 * 504 code (in `title`): `StickerGeneration.Timeout` — Vellum did not answer within the
 * server's generation budget (for the whole call, response body included; one attempt, no retry), or
 * a storage call timed out (a cancellation that was not the caller's own). No media row is
 * written; a late upload lands in `images/pending/`, is never published, and is removed by the
 * pending lifecycle rule. A timeout that fires after the publish copy finished on S3 (the server's
 * publish budget, or an S3 client timeout racing the copy) leaves the copied `images/ready/`
 * object unreferenced; nothing deletes it.
 * 500 codes (in `title`):
 * `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code falls outside the image-key
 * segment pattern; checked before Vellum, so nothing is billed or written; repeats for the same
 * activity), or
 * `Server failure` (an unexpected exception such as an S3 error other than not-found or an
 * undocumented store answer; worth retrying).
 * No media row is written; the current sticker (if any) is unchanged.
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/generations`.
 */
export const activityInstancesGenerateStickerResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesGenerateStickerData, ThrowOnError> | undefined) => httpResource<ActivityInstancesGenerateStickerResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesGenerateStickerRequest(opts) : undefined;
});

/**
 * Step 1 of a sticker upload (KT-1193) — prepare. The logged-in teacher gets a presigned POST
 * for one pending sticker key of an own activity instance, under the activity's tenant and the
 * caller's owner prefix. `fileName` supplies only the extension; `jpeg`, `jpe` and `jfif`
 * canonicalise to `jpg`. Creates no resource and writes nothing, so it answers 200 (the
 * `POST /v1/images` precedent). Not found, a colleague's instance or a template → 404
 * (`ActivityInstance.NotFound`, checked first). No 409 path: nothing is claimed or stored.
 * 500 codes (in `title`): `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code
 * falls outside the image-key segment pattern; repeats for the same activity), or
 * `Server failure` (an unexpected exception such as a presigning failure; worth retrying).
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/uploads`.
 */
export const activityInstancesPrepareStickerUploadResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesPrepareStickerUploadData, ThrowOnError> | undefined) => httpResource<ActivityInstancesPrepareStickerUploadResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesPrepareStickerUploadRequest(opts) : undefined;
});

/**
 * Step 2 of a sticker upload (KT-1193) — confirm. Rebuilds the sticker key from the activity's
 * tenant, the caller and `uploadId`; unless the image is already published, inspects the pending
 * object and publishes it (the `PATCH /v1/images/{id}` checks). Then one transaction locks the
 * activity row, adds the media row and makes it the current sticker. Idempotent: a repeated or
 * concurrent confirm of the same upload answers the same media row and adds none.
 * 500 codes (in `title`): `ImageStorageKey.InvalidTenantSegment` (the activity's tenant code
 * falls outside the image-key segment pattern; repeats for the same activity), or
 * `Server failure` (an unexpected exception such as an S3 error; worth retrying with the same
 * `uploadId`).
 * The runtime `/api` prefix comes from `Program.cs` → real URL
 * `/api/v1/activity-instances/{id}/sticker/uploads/{uploadId}`.
 */
export const activityInstancesConfirmStickerUploadResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesConfirmStickerUploadData, ThrowOnError> | undefined) => httpResource<ActivityInstancesConfirmStickerUploadResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesConfirmStickerUploadRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének altémáját. Mezőnkénti
 * (field-scoped) `PUT` a `sub-topic` alerőforráson, az `updateName`-mel megegyező szemantikával:
 * a törzs csak az új `value` (SubTopic-azonosító) mezőt hordozza. Az altéma létezését a szerver a
 * read-modellen (`SubTopics`) ellenőrzi; a `topicName` a válaszban az új altéma témájából
 * származik. Idegen tulajdonú, nem létező vagy Template-típusú sor → 404; ismeretlen
 * SubTopic-azonosító → 400 (a sor nem módosul). A tulajdonos-ellenőrzés MEGELŐZI az altéma
 * létezés-ellenőrzését, tehát nem látható sor + ismeretlen altéma → 404. Kivétel az üres
 * (`00000000-…`) azonosító: azt a kérés-validátor utasítja vissza a handler előtt → 400. Siker →
 * 200 + a frissített `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja → valós URL
 * `/api/v1/activity-instances/{id}/sub-topic`.
 */
export const activityInstancesUpdateSubTopicResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateSubTopicData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateSubTopicResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateSubTopicRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja a saját tevékenységének címkéit. Mezőnkénti (field-scoped)
 * `PUT` a `tags` alerőforráson: a kapott `value` a TELJES címkehalmazt lecseréli (az abból kimaradt
 * `activity_tags` sorok törlődnek, az újak létrejönnek, a megmaradók változatlanok) — nincs külön
 * add/remove művelet. Üres lista → minden címke törlődik. Idegen tulajdonú, nem létező vagy
 * Template-típusú sor → 404; ismeretlen vagy üres (`00000000-…`) tag-id → 400 (a sor nem módosul).
 * Siker → 200 + a frissített `detail` válasz. A futásidejű `/api` prefixet a `Program.cs` adja →
 * valós URL `/api/v1/activity-instances/{id}/tags`.
 */
export const activityInstancesUpdateTagsResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateTagsData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateTagsResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateTagsRequest(opts) : undefined;
});

/**
 * The signed-in teacher updates visibility (`Private` / `Tenant`) on their own activity. Owner filter
 * is part of the WHERE clause: foreign-owned, missing, or Template row → 404. Unknown value, or
 * `Tenant` from a caller without an institution → 400. Success → 200 + updated `detail`. URL
 * `/api/v1/activity-instances/{id}/visibility` (runtime `/api` prefix from `Program.cs`).
 */
export const activityInstancesUpdateVisibilityResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesUpdateVisibilityData, ThrowOnError> | undefined) => httpResource<ActivityInstancesUpdateVisibilityResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesUpdateVisibilityRequest(opts) : undefined;
});

/**
 * A pedagógus önálló, szerkeszthető másolatot hoz létre egy megtekintett tevékenységből (saját
 * `ActivityInstance` forrásból; sablont és kolléga megosztott instance-át az
 * `activity-templates/{id}:copy` másol). Google AIP-136 „custom method":
 * a nem-CRUD `copy` igét a kettőspontos `:copy` szuffix jelöli a member-scoped `{id}` erőforráson
 * (ld. ADR 10). A `{id}` a FORRÁS azonosítója; a törzs ÜRES (a szerver a másolandó mezőket a
 * forrásból olvassa, nincs felülírandó mező). Az eredmény mindig a hívó tulajdonában lévő új
 * `ActivityInstance`, `(másolat)` utótagú névvel; az eredeti sosem módosul. A Kontextus-dokumentumok
 * közül a másolatba azok kerülnek át, amelyeket a hívó most lát. `201 Created` + id-only
 * törzs (`id`) + `Location` fejléc az instance-GET-re (`CreatedAtRoute` →
 * `GetActivityInstanceById`). Nem látható forrás (idegen `ActivityInstance` vagy nem létező sor) →
 * 404; a képzett név > 255 → 400; hitelesítetlen hívó → 401. A futásidejű `/api` prefixet a
 * `Program.cs` adja → valós URL `/api/v1/activity-instances/{id}:copy`.
 */
export const activityInstancesCopyResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityInstancesCopyData, ThrowOnError> | undefined) => httpResource<ActivityInstancesCopyResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityInstancesCopyRequest(opts) : undefined;
});

/**
 * A pedagógus kérését megértett intentre fordítja. Ismeretlen tag-id vagy
 * altémakör-id → 400 (a workflow meg sem hívódik). A workflow elérhetetlensége,
 * sikertelen lefutása, valamint az az eset, amikor sikeres lefutás után sem ad
 * használható választ → 502; időtúllépése → 504 (legfeljebb kb. 45 másodperc).
 * Nem hoz létre és nem módosít semmit.
 */
export const activityIntentsInterpretResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityIntentsInterpretData, ThrowOnError> | undefined) => httpResource<ActivityIntentsInterpretResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityIntentsInterpretRequest(opts) : undefined;
});

/**
 * Érvénytelen bemenet, ismeretlen `subTopicId` vagy méret-túllépés → 400; hiányzó auth → 401;
 * a pedagógus sora nem létezik → 404 (nincs forrás-tevékenység lookup — a forrás-azonosító
 * hiánya a tervezett viselkedés, ez strukturálisan elérhetetlenné teszi a "forrás nem
 * található" hibát); a Dify-hívás elérhetetlen, elutasított vagy deszerializálhatatlan
 * választ ad → 502; időtúllépés → 504.
 */
export const activitySuggestionAdaptationAdaptResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivitySuggestionAdaptationAdaptData, ThrowOnError> | undefined) => httpResource<ActivitySuggestionAdaptationAdaptResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activitySuggestionAdaptationAdaptRequest(opts) : undefined;
});

/**
 * Szinkron módon generál egy fix darabszámú tevékenység-javaslatot a leírás és az opcionális
 * tag-azonosítók alapján; a valós Dify Activity Generator workflow-t hívja. A helyszín
 * (`location`) feloldásához a bejelentkezett pedagógust az `IUserContext` adja, amíg nincs
 * valós auth ez egy MVP-ben rögzített teacherId-ra mutat.
 * Érvénytelen bemenet → 400; generálási hiba → 502; időtúllépés → 504.
 * A válaszban a fix darabszámnál kevesebb elem → 502.
 */
export const activitySuggestionsGenerateResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivitySuggestionsGenerateData, ThrowOnError> | undefined) => httpResource<ActivitySuggestionsGenerateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activitySuggestionsGenerateRequest(opts) : undefined;
});

/**
 * Opcionális címke-path szűrők. Ismételt query paraméter: `?tagPath=a&tagPath=b`.
 * Path-ok dimenzióba csoportosítva: a dimenzió az első ltree szegmens (root), kivéve a
 * `tevekenyseg` root-ot, ahol az első két szegmens (`tevekenyseg.tipus`, `tevekenyseg.munkaforma`,
 * `tevekenyseg.eszkoz`):
 * - ugyanazon dimenzión belül OR + ancestor egyezés (`ltree <@`) a sablon bármely tagjére;
 * - különböző dimenziók között AND.
 * Hiányzó `tagPath` = nincs szűrés. Érvénytelen ltree path → 400.
 *
 * Opcionális `searchTerm` szabad szöveges keresés: ékezet- és kis-/nagybetű-érzéketlen
 * (`unaccent(...) ILIKE '%...%'`) összefüggő részszó-illesztés a `name`, `topicName`,
 * `subTopicName` és bármely `tags.label` mezőre (OR), a `tagPath` szűrővel AND-ben.
 * A LIKE-metakarakterek (`%`, `_`, `\`) literálként illeszkednek. Üres/whitespace
 * `searchTerm` = nincs keresési szűrés. Maximális hossz 100 karakter; túllépés → 400.
 *
 * `limit` alapértelmezés: 20, tartomány: 1–100.
 */
export const activityTemplatesListResource = <ThrowOnError extends boolean = false>(options?: () => Options<ActivityTemplatesListData, ThrowOnError> | undefined) => httpResource<ActivityTemplatesListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityTemplatesListRequest(opts) : undefined;
});

/**
 * Details of an activity shared with the caller's tenant: a template of the caller's tenant, or a
 * `Tenant`-visibility instance in the caller's tenant — a colleague's or the caller's own — always
 * read-only (`isOwner` false). A `Private` instance, even the caller's own, → 404; its detail is
 * `GET /v1/activity-instances/{id}`. Every row of another tenant, and an unknown id → 404.
 */
export const activityTemplatesDetailResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityTemplatesDetailData, ThrowOnError> | undefined) => httpResource<ActivityTemplatesDetailResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityTemplatesDetailRequest(opts) : undefined;
});

/**
 * A pedagógus önálló, szerkeszthető `ActivityInstance`-t hoz létre a saját intézményének egy
 * `ActivityTemplate`-jéből. Google AIP-136 „custom method": a nem-CRUD `copy` igét a kettőspontos
 * `:copy` szuffix jelöli a member-scoped `{id}` erőforráson (ld. ADR 10). A `{id}` a FORRÁS template
 * azonosítója; a törzs ÜRES (a szerver a másolandó mezőket a forrásból olvassa). Az eredmény mindig a
 * hívó tulajdonában lévő új `ActivityInstance`, `(másolat)` utótagú névvel; a forrás template sosem
 * módosul. `201 Created` + id-only törzs (`id`) + `Location` fejléc az instance-GET-re
 * (`CreatedAtRoute` → `GetActivityInstanceById`, tehát az új `ActivityInstance`-re, NEM a template-re).
 * The source may be any `Tenant`-visibility instance in the caller's tenant, a colleague's or the
 * caller's own — the same set `detail` opens; the copy is the caller's own `Private` instance. Of an
 * instance source's context documents, the copy carries only those the caller may see: their own and
 * the tenant-shared ones, never the colleague's private ones (KT-851 FR-6.3). A
 * `Private` instance, even the caller's own, a row of another tenant, or an unknown id → 404; derived
 * name > 255 → 400; unauthenticated caller → 401. A futásidejű `/api` prefixet a `Program.cs` adja →
 * valós URL `/api/v1/activity-templates/{id}:copy`.
 */
export const activityTemplatesCopyResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityTemplatesCopyData, ThrowOnError> | undefined) => httpResource<ActivityTemplatesCopyResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityTemplatesCopyRequest(opts) : undefined;
});

/**
 * A strukturált teacher input (`description` + opcionális tagek / NAT / duration)
 * alapján ajánlott tevékenység-altípusokat ad vissza a `GetTagsItem` szerkezetében.
 * Ismeretlen tag-id vagy altémakör-id → kihagyás + warning log (a workflow a
 * feloldott mezőkkel továbbra is meghívódik). Ha egyetlen Label sem oldható fel,
 * vagy a workflow lefutott, de nem adott ajánlást, a válasz üres tömb (200); a workflow
 * sikertelen lefutása, elérhetetlensége vagy időtúllépése (legfeljebb kb. 45 másodperc) → 500.
 */
export const activityTypeRecommendationsRecommendResource = <ThrowOnError extends boolean = false>(options: () => Options<ActivityTypeRecommendationsRecommendData, ThrowOnError> | undefined) => httpResource<ActivityTypeRecommendationsRecommendResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? activityTypeRecommendationsRecommendRequest(opts) : undefined;
});

/**
 * Egy melléklet tartalmának elérése rövid életű, aláírt (presigned) S3 URL-en át.
 * A válasz 302 átirányítás — a fájl bájtjai sosem mennek át a backenden.
 * A friss URL kérésenként keletkezik, így a detail panel nyitva tartása nem okoz lejárt linket.
 * A `mode` kötelező: `view` → inline megnyitás; `download` → letöltés (`Content-Disposition`).
 * Ismeretlen `attachmentId` → 404.
 */
export const attachmentsAttachmentContentResource = <ThrowOnError extends boolean = false>(options: () => Options<AttachmentsAttachmentContentData, ThrowOnError> | undefined) => httpResource<unknown>(() => {
    const opts = options ? options() : undefined;
    return opts ? attachmentsAttachmentContentRequest(opts) : undefined;
});

/**
 * A hívó saját eseményei és a kollégák `Tenant` láthatóságú eseményei egy időablakra, keyset-lapozva.
 *
 * Időablak: `start`/`end` hiányában az aktuális ISO-hét (hétfő 00:00 UTC – következő hétfő
 * 00:00 UTC); ha csak az egyik érkezik, az ablak onnan (vagy odáig) 7 nap. `start >= end` → 400.
 * Az ablak UTC-alapú, nem a hívó helyi hete — a kliens explicit `start`/`end`-del határozza meg
 * a saját zónájának heti határait.
 *
 * Rendezés: `startsAt`, majd `id` (keyset). A `cursor` az előző lap `nextCursor`-a, opaque
 * string — a kliens ne értelmezze. `limit` alapértelmezés: 20, tartomány: 1–100.
 * `totalCount` ezen a végponton nincs kitöltve.
 *
 * A kukázott (soft delete) események is benne vannak a válaszban, `isDeleted: true`-val — a
 * naptár megjeleníti és onnan állítható vissza őket (PUT `deleted: false`). Kollégák `Tenant`
 * eseményei közül a kukázottak nem jelennek meg (`isDeleted` colleague branch).
 */
export const calendarEventsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<CalendarEventsListData, ThrowOnError> | undefined) => httpResource<CalendarEventsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventsListRequest(opts) : undefined;
});

/**
 * `endsAt` hiányában az esemény hossza 45 perc (egy tanóra). `visibility: Tenant` tenant nélküli
 * hívótól → 400 (`ValidationProblemResponse`), ugyanúgy mint a visibility PATCH.
 */
export const calendarEventsScheduleResource = <ThrowOnError extends boolean = false>(options: () => Options<CalendarEventsScheduleData, ThrowOnError> | undefined) => httpResource<CalendarEventsScheduleResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventsScheduleRequest(opts) : undefined;
});

/**
 * Csak a tulajdonos törölhet; idegen vagy láthatatlan sor → 404.
 */
export const calendarEventByIdDeleteResource = <ThrowOnError extends boolean = false>(options: () => Options<CalendarEventByIdDeleteData, ThrowOnError> | undefined) => httpResource<CalendarEventByIdDeleteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventByIdDeleteRequest(opts) : undefined;
});

/**
 * Saját esemény (minden visibility) és kolléga `Tenant` esemény → 200, read-only ha `isOwner` false.
 * Idegen `Private` vagy láthatatlan sor → 404.
 */
export const calendarEventByIdDetailResource = <ThrowOnError extends boolean = false>(options: () => Options<CalendarEventByIdDetailData, ThrowOnError> | undefined) => httpResource<CalendarEventByIdDetailResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventByIdDetailRequest(opts) : undefined;
});

/**
 * Teljes-csere: minden mutable mező jelen. A `deleted` a soft-delete állapot (Google Drive
 * `trashed`-minta): `true` = kukába, `false` = visszaállítás. A `DELETE` ige ettől külön a végleges törlés.
 *
 * Konkurencia: a kérés nem hordoz verziót, a szemantika **last write wins** — két egyidejű
 * szerkesztés közül a később beérkező felülírja a korábbit, 409 nélkül. Nem tulajdonos (kolléga
 * `Tenant` esemény) → 404.
 */
export const calendarEventByIdUpdateResource = <ThrowOnError extends boolean = false>(options: () => Options<CalendarEventByIdUpdateData, ThrowOnError> | undefined) => httpResource<CalendarEventByIdUpdateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventByIdUpdateRequest(opts) : undefined;
});

/**
 * The signed-in teacher updates visibility (`Private` / `Tenant`) on their own calendar event. Foreign-owned,
 * missing, or invisible row → 404. Unknown value, or `Tenant` from a caller without an institution → 400.
 * Success → 200 + full `detail` body (mirror activity visibility PATCH).
 */
export const calendarEventByIdUpdateVisibilityResource = <ThrowOnError extends boolean = false>(options: () => Options<CalendarEventByIdUpdateVisibilityData, ThrowOnError> | undefined) => httpResource<CalendarEventByIdUpdateVisibilityResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? calendarEventByIdUpdateVisibilityRequest(opts) : undefined;
});

/**
 * The documents the signed-in teacher may see inside their tenant: their own (`owner_id` ==
 * IUserContext.UserId), plus other teachers' documents whose visibility is `Tenant`. Another
 * teacher's `Private` document never appears. Each item's `isOwner` tells the caller's own apart.
 * Optional filters: `searchTerm` (fileName ILIKE), `fileType` (lowercased extension),
 * `status` (`DocumentStatus`; absent = every state), `visibility` (`DocumentVisibility`; absent = every value).
 * Paging: `page` (1-based), `pageSize` (1–100, default 10).
 * Sort: `sortBy` (`createdAt` | `fileName` | `fileType` | `fileSizeBytes` | `status` | `visibility` |
 * `ownerName`; default `createdAt`) + `sortDir` (`asc` | `desc`; default `desc`).
 */
export const documentsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<DocumentsListData, ThrowOnError> | undefined) => httpResource<DocumentsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentsListRequest(opts) : undefined;
});

/**
 * Step 2 — batch confirmation (the PATCH changes the state of the referenced documents).
 * The server HEADs each landed object, rejects and deletes anything over the 50 MB cap, and also
 * reads the first 16 KiB — a bounded, ranged read, never a full object transfer — to check the
 * detected content type against the type the declared extension promises, answering
 * `rejectedContentType` in the three cases listed on that enum member; the zero-byte case is
 * caught on the object's size, before any ranged read. Everything else moves to Uploaded, which
 * the poller then indexes. No document byte is transferred through the API on any path, and this
 * request makes no outbound call to Agno: submission stays with the poller.
 * Idempotent: a record already past `Pending` comes back as `uploaded`.
 * Unknown `state`, or a batch that is empty or larger than ten → 400; missing identity → 401.
 */
export const documentsConfirmResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentsConfirmData, ThrowOnError> | undefined) => httpResource<DocumentsConfirmResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentsConfirmRequest(opts) : undefined;
});

/**
 * Step 1 — batch open. Validation (1..10 files, allowed extension, declared size > 0), a per-user
 * slot check (max 20 non-`Indexed` records), then per file a Pending record with a
 * server-generated `storage_key` and a presigned PUT URL. The bytes never touch the API.
 * Errors → 400 ProblemDetails (empty or oversized batch, forbidden extension, slot limit);
 * missing identity → 401.
 */
export const documentsOpenResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentsOpenData, ThrowOnError> | undefined) => httpResource<DocumentsOpenResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentsOpenRequest(opts) : undefined;
});

/**
 * Hard delete of the caller's own document from the KT database. Ownership: `owner_id`.
 * The record and the cascading join rows commit first; only then does the best-effort Agno delete
 * run (`DELETE /documents/{knowledge_ref}/{document_id}`, knowledge_ref = the configured
 * KnowledgesId; an Agno failure does not undo the local delete that already happened, and an Agno
 * 404 counts as success), followed — if a `storage_key` exists — by the best-effort object-store
 * delete (S3 `DeleteObject`), which also removes the object from the bucket.
 * Foreign or missing record → 404; missing auth → 401. Success → 204.
 */
export const documentByIdDeleteResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentByIdDeleteData, ThrowOnError> | undefined) => httpResource<DocumentByIdDeleteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentByIdDeleteRequest(opts) : undefined;
});

/**
 * Metadata and status of the caller's own document (`owner_id` == IUserContext.UserId).
 * Poll this, not the first page of the list. Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdGetResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentByIdGetData, ThrowOnError> | undefined) => httpResource<DocumentByIdGetResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentByIdGetRequest(opts) : undefined;
});

/**
 * How many of the caller's own activities the document is attached to. A COUNT over the join table
 * with an owner filter. Not part of the list response.
 * Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdGetActivityUsageResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentByIdGetActivityUsageData, ThrowOnError> | undefined) => httpResource<DocumentByIdGetActivityUsageResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentByIdGetActivityUsageRequest(opts) : undefined;
});

/**
 * Sets who may see the document beyond the owner (`documents.visibility`). Only the owner
 * (`owner_id` == IUserContext.UserId) may change visibility. Writable values: `Private`, `Tenant`
 * (`Tenant` requires tenant context). Foreign or missing record → 404; missing auth → 401.
 */
export const documentByIdUpdateVisibilityResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentByIdUpdateVisibilityData, ThrowOnError> | undefined) => httpResource<DocumentByIdUpdateVisibilityResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentByIdUpdateVisibilityRequest(opts) : undefined;
});

/**
 * The signed-in teacher downloads an `Indexed` document they may see: their own (`owner_id` ==
 * IUserContext.UserId) or one a colleague shared with the tenant (`visibility` `Tenant`), such as a
 * context document of a colleague's shared activity (KT-851 FR-6.4). The response is a 302 redirect to
 * a short-lived presigned S3 GET URL (`Content-Disposition: attachment`); bytes never pass through
 * the API. A colleague's `Private` document, another tenant's document, or a missing record → 404;
 * visible but not `Indexed` → 400; missing auth → 401.
 * Not the catalog attachment download (`GET /v1/attachments/{attachmentId}`).
 */
export const documentByIdDownloadResource = <ThrowOnError extends boolean = false>(options: () => Options<DocumentByIdDownloadData, ThrowOnError> | undefined) => httpResource<unknown>(() => {
    const opts = options ? options() : undefined;
    return opts ? documentByIdDownloadRequest(opts) : undefined;
});

/**
 * Step 1 — open. Mints the image's id and returns a presigned POST for its one key under the
 * caller's own tenant and owner prefix. Writes nothing.
 */
export const imagesOpenResource = <ThrowOnError extends boolean = false>(options: () => Options<ImagesOpenData, ThrowOnError> | undefined) => httpResource<ImagesOpenResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? imagesOpenRequest(opts) : undefined;
});

/**
 * Step 2 — confirm. Rebuilds the key from the caller and the id; if the image is already
 * published, answers its path at once. Otherwise HEADs the current pending version, inspects
 * its first 16 KiB, and publishes exactly that version — a server-side copy to the location
 * the media host serves; publishing is what makes it served. A rejected version is never
 * copied and stays unserved. The `ready`/`rejected` status tag is best-effort bookkeeping: a
 * storage failure while tagging (reported or thrown by S3) is logged and never changes the
 * answer. Idempotent for a published image.
 */
export const imagesConfirmResource = <ThrowOnError extends boolean = false>(options: () => Options<ImagesConfirmData, ThrowOnError> | undefined) => httpResource<ImagesConfirmResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? imagesConfirmRequest(opts) : undefined;
});

/**
 * A seedelt intézmény lekérdezése. Egyetlen intézmény feltételezés: az első
 * (és egyetlen) seedelt sort adja vissza. Seed hiányában `404`
 * (`Institution.NotFound`). Read-only, `AllowAnonymous`.
 */
export const institutionGetResource = <ThrowOnError extends boolean = false>(options?: () => Options<InstitutionGetData, ThrowOnError> | undefined) => httpResource<InstitutionGetResponse>(() => {
    const opts = options ? options() : {};
    return institutionGetRequest(opts);
});

/**
 * Lists members of the caller's MTP tenant (BFF over MTP `GET …/members`).
 * Returns every row MTP sends in one response (up to MTP's 5,000-member cap).
 * Requires `member.read` on the stored platform snapshot. Without it → `403`.
 * When MTP integration is not configured → `503`.
 * No teacher row for the caller → `404` (`Members.TeacherNotFound`).
 * MTP gateway failures → `502` / `504` (stable codes in ProblemDetails `title`, e.g.
 * `Mtp.Members.Unavailable`, `Mtp.Members.MalformedAnswer`, `Mtp.Members.Timeout`).
 */
export const membersListResource = <ThrowOnError extends boolean = false>(options?: () => Options<MembersListData, ThrowOnError> | undefined) => httpResource<MembersListResponse>(() => {
    const opts = options ? options() : {};
    return membersListRequest(opts);
});

/**
 * Invites a new member for the caller's MTP tenant instance (BFF over MTP `POST …/members`).
 * Requires `member.invite` on the stored platform snapshot. Without it → `403`.
 * Duplicate e-mail in tenant → `409`. KT-local validation → `400`. MTP business-rule failures → `422`.
 */
export const membersCreateResource = <ThrowOnError extends boolean = false>(options: () => Options<MembersCreateData, ThrowOnError> | undefined) => httpResource<MembersCreateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? membersCreateRequest(opts) : undefined;
});

/**
 * Deactivates a member (BFF over MTP `POST …/members/{userId}/deactivate`).
 * Requires `member.deactivate` on the snapshot. Success → `204`.
 */
export const membersDeactivateResource = <ThrowOnError extends boolean = false>(options: () => Options<MembersDeactivateData, ThrowOnError> | undefined) => httpResource<MembersDeactivateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? membersDeactivateRequest(opts) : undefined;
});

/**
 * Resends the invitation for an inactive member (BFF over MTP `POST …/members/{userId}/resend-invite`).
 * Requires `member.invite` on the snapshot. Success → `204`.
 */
export const membersResendInviteResource = <ThrowOnError extends boolean = false>(options: () => Options<MembersResendInviteData, ThrowOnError> | undefined) => httpResource<MembersResendInviteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? membersResendInviteRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus SAJÁT projektjei (owner == IUserContext.UserId), TELJES listaként:
 * nincs lapozási és nincs keresési query paraméter (Q8, Q25). Sorrend: `createdAt` szerint
 * csökkenő, azonos időbélyegnél `id ASC` tie-break (Q29).
 * Üres projektek is szerepelnek. Más pedagógus projektjei nem.
 */
export const projectsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<ProjectsListData, ThrowOnError> | undefined) => httpResource<ProjectsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectsListRequest(opts) : undefined;
});

/**
 * Kézi projektlétrehozás a „Projektek" fejléc „+ Új projekt" gombjával. Üresen is
 * elmentődik — a mentés kötelező feltétele a nem üres (trim után) név; a leírás opcionális.
 * Siker: `201 Created` + `Location` fejléc (`GET /v1/projects/{projectId}`) + `ProjectDetail` törzs.
 * **404** = érvényes token, de nincs teacher rekord (konzisztens idegen erőforrással).
 * Új aggregátum jön létre, nincs mihez ütközni — ezért **nincs 409**.
 */
export const projectsCreateResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectsCreateData, ThrowOnError> | undefined) => httpResource<ProjectsCreateResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectsCreateRequest(opts) : undefined;
});

/**
 * Projekt törlése. CSAK a projektet és a tevékenység-előfordulásait törli — a tevékenységek
 * a könyvtárban maradnak. Idegen/hiányzó projekt → 404.
 *
 * Konkurencia: optimista. Ha a projekt időközben megváltozott vagy már törölték, a hívó kérése
 * („legyen törölve") teljesült — a válasz **404**, nem 409: nincs mit újrapróbálni.
 */
export const projectByIdDeleteResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectByIdDeleteData, ThrowOnError> | undefined) => httpResource<ProjectByIdDeleteResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectByIdDeleteRequest(opts) : undefined;
});

/**
 * Részletnézet: fejléc + sorrendezett tevékenységlista. Idegen/hiányzó projekt → 404.
 */
export const projectByIdDetailResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectByIdDetailData, ThrowOnError> | undefined) => httpResource<ProjectByIdDetailResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectByIdDetailRequest(opts) : undefined;
});

/**
 * Meglévő tevékenységek hozzáadása. A UI egykattintásos + gombbal egyelemű `activityIds` tömböt küld;
 * a batch atomi (`@minItems(1)` — üres tömb → 400). Ugyanaz a tevékenység többször is hozzáadható —
 * minden hívás új előfordulást hoz létre a lista végére, a batch elemeinek sorrendjében.
 *
 * Hozzáadható tevékenység = a hívó intézményének sablonja, a bejelentkezett pedagógus saját
 * instance-a, vagy egy kolléga intézménnyel megosztott (`Tenant` láthatóságú) instance-a — ugyanaz a
 * halmaz, amit a könyvtár mutat. **400** = üres batch (`@minItems(1)`), validáció. **404** = minden más
 * tevékenység (egy kolléga privát instance-a, egy másik intézmény bármely sora), nem létező id,
 * idegen/hiányzó projekt (nincs adatszivárgás). **409** = a projekt közben megváltozott.
 */
export const projectActivitiesAddResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectActivitiesAddData, ThrowOnError> | undefined) => httpResource<ProjectActivitiesAddResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectActivitiesAddRequest(opts) : undefined;
});

/**
 * „Duplikálás" a projekt részletnézetének kártya-menüjéből (KT-338): egyetlen hívás létrehozza a
 * tevékenység másolatát a pedagógus könyvtárában, ÉS bemásolja azt ebbe a projektbe, a lista végére.
 * A másolat mindig saját `Instance`, akkor is, ha a forrás sablon vagy egy kolléga megosztott instance-a volt.
 *
 * A cél projekt a path-ból derül ki, ezért a másolat SOHA nem kerül be a forrás többi projektjébe —
 * a művelet a hívás helye szerinti egyetlen projektet érinti.
 *
 * Atomi: a másolat és az előfordulás egyetlen tranzakcióban jön létre, így nem marad árva másolat a
 * könyvtárban, ha a projekt írása meghiúsul.
 *
 * Másolható forrás = a hívó intézményének sablonja, a bejelentkezett pedagógus saját instance-a,
 * vagy egy kolléga intézménnyel megosztott instance-a — ugyanaz a szabály, mint az `add`-nál. A forrás
 * Kontextus-dokumentumai közül a másolatba csak azok kerülnek át, amelyeket a hívó lát: a sajátjai és a
 * tenanttal megosztottak (KT-851 FR-6.3).
 * **404** = minden más tevékenység, nem létező tevékenység, idegen/hiányzó projekt (adatszivárgás
 * nélkül). **409** = a projekt közben megváltozott.
 * AIP-136 custom method (`:copy`), a könyvtári `activity-instances/{id}:copy` mintájára.
 */
export const projectActivitiesCopyResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectActivitiesCopyData, ThrowOnError> | undefined) => httpResource<ProjectActivitiesCopyResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectActivitiesCopyRequest(opts) : undefined;
});

/**
 * „Kivétel a projektből" — CSAK a projektbeli előfordulást törli (`projectActivityId`), a tevékenység
 * (`activityId`) a könyvtárban marad. Siker: frissített `ProjectDetail` (mint `add`).
 * Hiányzó előfordulás, a `projectActivityId` másik projekthez tartozik, vagy az előfordulás a hívó
 * elől rejtett (a részletnézet sem mutatja) → 404 (adatszivárgás nélkül).
 * Ne keverjük a könyvtári tevékenységtörléssel (az `activityId`-t címzi, minden projektből kiveszi).
 * **409** = a projekt közben megváltozott.
 */
export const projectActivitiesRemoveResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectActivitiesRemoveData, ThrowOnError> | undefined) => httpResource<ProjectActivitiesRemoveResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectActivitiesRemoveRequest(opts) : undefined;
});

/**
 * Drag and drop utáni átrendezés (Q33): a body a projekt tevékenység-előfordulásainak **teljes**
 * listája a kívánt sorrendben. A művelet idempotens, és a projekt tárolt sorrendjét pontosan erre
 * a listára írja át — egy korábbi kivétel után maradt sorrend-hiány is megszűnik.
 *
 * **400** = üres vagy nem-UUID elemeket tartalmazó lista. **404** = idegen/hiányzó projekt.
 * **409** = a beküldött halmaz nem egyezik a projekt aktuális tevékenységeivel (hiányzó, többlet
 * vagy ismétlődő elem — elavult kliens-lista), vagy a projekt közben megváltozott.
 * A FE sorosítás csak UX — nem helyettesíti a szerveroldali konkurencia-ellenőrzést.
 * AIP-136 custom method (`:reorder`).
 */
export const projectActivitiesReorderResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectActivitiesReorderData, ThrowOnError> | undefined) => httpResource<ProjectActivitiesReorderResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectActivitiesReorderRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus módosítja vagy üríti a saját projektjének leírását. Mezőnkénti
 * (field-scoped) `PUT` a `description` alerőforráson, az `updateName`-mel megegyező szemantikával.
 * Az ürítés a feature része, nem hiba: `null` és üres string egyaránt törli a leírást, és a
 * `ProjectDetail` válaszban a `description` ilyenkor hiányzik. Idegen vagy nem létező projekt →
 * 404; 2000 karakternél hosszabb leírás → 400 (a sor nem módosul). Siker → 200 + a teljes friss
 * `ProjectDetail`. Ha a projekt időközben megváltozott → 409.
 */
export const projectByIdUpdateDescriptionResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectByIdUpdateDescriptionData, ThrowOnError> | undefined) => httpResource<ProjectByIdUpdateDescriptionResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectByIdUpdateDescriptionRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus átnevezi a saját projektjét. Mezőnkénti (field-scoped) `PUT` a `name`
 * alerőforráson: a törzs csak az új értéket (`value`) hordozza, így a részletnézet inline
 * szerkesztésének autosave-e nem küldi vissza a teljes erőforrást. A tulajdonos-szűrő a WHERE
 * feltétel része, ezért idegen vagy nem létező projekt → 404, létezés-szivárgás nélkül. Üres,
 * csak whitespace vagy 255 karakternél hosszabb név → 400 (a sor nem módosul). Siker → 200 + a
 * teljes friss `ProjectDetail` (read-your-writes). Ha a projekt időközben megváltozott, az
 * aggregátum verzió-tokenje elutasítja az írást → 409.
 */
export const projectByIdUpdateNameResource = <ThrowOnError extends boolean = false>(options: () => Options<ProjectByIdUpdateNameData, ThrowOnError> | undefined) => httpResource<ProjectByIdUpdateNameResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? projectByIdUpdateNameRequest(opts) : undefined;
});

/**
 * Opcionális `path` + `depth` szűrés: csak a megadott path alatt,
 * pontosan `depth` szinttel lejjebb lévő tagek (ltree exact-depth).
 * `depth` alapértelmezés: 1. Paraméterek nélkül a teljes flat lista.
 */
export const tagsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<TagsListData, ThrowOnError> | undefined) => httpResource<TagsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? tagsListRequest(opts) : undefined;
});

/**
 * A bejelentkezett pedagógus alapadatait és profilját (tag-ek id + path párként) adja vissza.
 * `hasProfile: false` esetén a kliens a profil-rögzítő képernyőre irányít.
 * `404` ha a Keycloak-identitáshoz nem tartozik teacher-rekord.
 */
export const teachersMeResource = <ThrowOnError extends boolean = false>(options?: () => Options<TeachersMeData, ThrowOnError> | undefined) => httpResource<TeachersMeResponse>(() => {
    const opts = options ? options() : {};
    return teachersMeRequest(opts);
});

/**
 * A bejelentkezett pedagógus tanítási profilját adja vissza.
 * `404` ha még nincs profil (a kliens ezt a kapu-döntésre is felhasználhatja).
 */
export const teachersGetProfileResource = <ThrowOnError extends boolean = false>(options?: () => Options<TeachersGetProfileData, ThrowOnError> | undefined) => httpResource<TeachersGetProfileResponse>(() => {
    const opts = options ? options() : {};
    return teachersGetProfileRequest(opts);
});

/**
 * A bejelentkezett pedagógus tanítási profiljának szerkesztése: a megadott
 * egyedi tag-id halmaz a teljes tag-kollekciót lecseréli (dimenzió-agnosztikus).
 * Érvénytelen kérés (üres vagy nem-egyedi `tagIds`) → `400 Bad Request`.
 */
export const teachersUpdateProfileResource = <ThrowOnError extends boolean = false>(options: () => Options<TeachersUpdateProfileData, ThrowOnError> | undefined) => httpResource<TeachersUpdateProfileResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? teachersUpdateProfileRequest(opts) : undefined;
});

/**
 * Egyszeri tanítási profil rögzítése a bejelentkezett pedagógushoz.
 * Ha már van profil, `409 Conflict` választ ad.
 * Érvénytelen kérés (pl. hiányzó vagy üres `tagIds`) → `400 Bad Request`.
 * `201 Created` sikeres mentés esetén.
 */
export const teachersCreateProfileResource = <ThrowOnError extends boolean = false>(options: () => Options<TeachersCreateProfileData, ThrowOnError> | undefined) => httpResource<TeachersCreateProfileResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? teachersCreateProfileRequest(opts) : undefined;
});

/**
 * Tagek (path + depth szerint szűrve, mint a `GET /v1/tags`), és mindegyik alatt
 * a hozzá tartozó topicok a sub-topicjaikkal, egy válaszban.
 *
 * Csak az a tag jön vissza, amelyhez tartozik legalább egy topic, aminek van
 * legalább egy sub-topicja; a sub-topic nélküli topicok kimaradnak. Így a
 * `?path=tantargy&depth=1` a tantárgy-tageket adja (pl. `tantargy.angol`,
 * `tantargy.fizika`) a hozzájuk tartozó topic/sub-topic fával.
 *
 * `depth` alapértelmezés: 1, engedett tartomány 0–4. Paraméterek nélkül minden tag,
 * ugyanezzel a szűréssel.
 */
export const topicTagsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<TopicTagsListData, ThrowOnError> | undefined) => httpResource<TopicTagsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? topicTagsListRequest(opts) : undefined;
});

/**
 * Topics (each with its sub-topics joined), ordered by name. Plain list, no pagination.
 *
 * The optional `tagId` narrows the list to the topics tagged with one `tantargy.*`
 * subject tag id (obtained from `GET /v1/tags?path=tantargy&depth=1`), filtering via
 * the `topic_tags` join; an unknown or unlinked tag id returns 200 with an empty list.
 * Omitting `tagId` returns every topic, including those linked to no subject tag.
 */
export const topicsListResource = <ThrowOnError extends boolean = false>(options?: () => Options<TopicsListData, ThrowOnError> | undefined) => httpResource<TopicsListResponse>(() => {
    const opts = options ? options() : undefined;
    return opts ? topicsListRequest(opts) : undefined;
});
